/* Slovak texts, keyed by the English source text (see i18n.ts). */
export const SK: Record<string, string> = {
  'Picked {c}.':
    'Vybraná farba {c}.',
  'Picked {c} (not in the palette – add it with “From drawing”).':
    'Vybraná farba {c} (nie je v palete – pridajte ju tlačidlom „Z kresby“).',
  'No painted area under the cursor.':
    'Pod kurzorom nie je žiadna vyfarbená plocha.',
  'My palette':
    'Moja paleta',
  'Could not read this file as SVG.':
    'Tento súbor sa nedá načítať ako SVG.',
  'From file':
    'Zo súboru',
  'The file’s colors were added as the palette “{name}”.':
    'Farby zo súboru boli pridané ako paleta „{name}“.',
  'Discard unsaved changes to the current drawing?\n(A copy is kept in History.)':
    'Zahodiť neuložené zmeny v aktuálnej kresbe?\n(Kópia zostane v Histórii.)',
  'Before opening {name}':
    'Pred otvorením {name}',
  'Opened {name}':
    'Otvorené: {name}',
  'Saved {name}':
    'Uložené: {name}',
  'File name:':
    'Názov súboru:',
  'PNG width in pixels:':
    'Šírka PNG v pixeloch:',
  'Invalid width.':
    'Neplatná šírka.',
  'PNG export failed.':
    'Export do PNG zlyhal.',
  'Before starting a new drawing':
    'Pred založením novej kresby',
  'Applied the grout color and width to {n} {n|line|lines}.':
    'Farba a šírka škár bola použitá na {n} {n|čiaru|čiary|čiar}.',
  'Autosave failed – remember to save your file.':
    'Automatické ukladanie zlyhalo – nezabudnite súbor uložiť.',
  'Autosave':
    'Automatické uloženie',
  'Before restoring an older version':
    'Pred obnovením staršej verzie',
  'Restored the version from {time}':
    'Obnovená verzia z {time}',
  'Symmetry center set.':
    'Stred symetrie je nastavený.',
  'Snapping on':
    'Prichytávanie zapnuté',
  'Snapping off':
    'Prichytávanie vypnuté',
  'The clipboard has no color codes.':
    'V schránke nie sú žiadne kódy farieb.',
  '{n} {n|area|areas}':
    '{n} {n|plocha|plochy|plôch}',
  'fill':
    'výplň',
  'stroke':
    'obrys',
  'No color – the bucket erases with it':
    'Bez farby – vedro ňou maže',
  'Recolored {n} {n|element|elements}.':
    'Prefarbené: {n} {n|prvok|prvky|prvkov}.',
  'Click on the canvas to place the symmetry center.':
    'Kliknite na plátno a umiestnite stred symetrie.',
  'Photo unlocked: drag it with the Select tool (where there are no shapes).':
    'Fotka je odomknutá: presuňte ju nástrojom Výber (tam, kde nie sú tvary).',
  'Remove the tracing photo?':
    'Odstrániť fotku na obkreslenie?',
  'Invalid page size.':
    'Neplatná veľkosť stránky.',
  '1 drawing unit = 1 {unit}. Set the page size to the real size of your mosaic.':
    '1 jednotka kresby = 1 {unit}. Nastavte veľkosť stránky na skutočnú veľkosť mozaiky.',
  'Could not read that image.':
    'Obrázok sa nedá načítať.',
  'Photo loaded and locked. Unlock it to move it with the Select tool.':
    'Fotka je načítaná a zamknutá. Ak ju chcete posunúť nástrojom Výber, odomknite ju.',
  'Replace the photo to trace with the pasted image?':
    'Nahradiť fotku na obkreslenie vloženým obrázkom?',
  'The pasted image is now the photo to trace – “Make a mosaic from the photo” turns it into tiles.':
    'Vložený obrázok je teraz fotkou na obkreslenie – „Vytvoriť mozaiku z fotky“ z neho urobí dlaždice.',
  'Replace photo…':
    'Nahradiť fotku…',
  'Load photo…':
    'Načítať fotku…',
  'Close shape':
    'Uzavrieť tvar',
  'Done':
    'Hotovo',
  'Start the cut inside a closed area.':
    'Rez začnite vnútri uzavretej plochy.',
  'Click inside a closed area (or use “Fill whole page”).':
    'Kliknite dovnútra uzavretej plochy (alebo použite „Vyplniť celú stránku“).',
  'That would be about {n} tiles – make the tile size bigger.':
    'To by bolo asi {n} {n|dlaždica|dlaždice|dlaždíc} – zväčšite veľkosť dlaždíc.',
  'The tiles are bigger than this area.':
    'Dlaždice sú väčšie ako táto plocha.',
  'This adds {n} lines, which may make editing slow. Continue?':
    'Pribudne {n} {n|čiara|čiary|čiar}, čo môže spomaliť úpravy. Pokračovať?',
  'Added the pattern “{type}” ({n} {n|line|lines}).':
    'Pridaný vzor „{type}“ ({n} {n|čiara|čiary|čiar}).',
  'The rows are wider than this area – use a smaller size.':
    'Rady sú širšie ako táto plocha – použite menšiu veľkosť.',
  'This area is too narrow for a row of that width.':
    'Táto plocha je na rad takej šírky príliš úzka.',
  'Added {rows} {rows|row line|row lines} and {cuts} {cuts|cut|cuts} following the outline.':
    'Pridané {rows} {rows|čiara radu|čiary radov|čiar radov} a {cuts} {cuts|rez|rezy|rezov} pozdĺž obrysu.',
  'Painted areas are locked or hidden (see Layers).':
    'Vyfarbené plochy sú zamknuté alebo skryté (pozri Vrstvy).',
  'No closed area here. The red circles show line ends that don’t touch anything.':
    'Tu nie je uzavretá plocha. Červené krúžky ukazujú konce čiar, ktoré sa ničoho nedotýkajú.',
  'No closed area here – make sure the lines meet.':
    'Tu nie je uzavretá plocha – skontrolujte, či sa čiary stretávajú.',
  'Click to select (Shift adds) · drag to move – the nearest corner snaps · drag handles to edit; shared corners move together (Alt detaches) · yellow handles resize a polygon':
    'Kliknutím vyberiete (Shift pridá) · ťahaním posuniete – prichytí sa najbližší roh · ťahaním úchytov upravíte; spoločné rohy sa posúvajú spolu (Alt ich oddelí) · žlté úchyty menia veľkosť mnohouholníka',
  'Click–click or drag · ends snap to points and onto other lines · Shift: 15° steps · Alt: no snap · Esc: stop':
    'Klik–klik alebo ťahanie · konce sa prichytia k bodom a na iné čiary · Shift: kroky po 15° · Alt: bez prichytávania · Esc: koniec',
  'Click corner by corner · click the first corner, double-click or press Enter to close · Backspace removes the last corner · Esc cancels':
    'Klikajte roh po rohu · tvar uzavriete kliknutím na prvý roh, dvojklikom alebo klávesom Enter · Backspace odoberie posledný roh · Esc zruší',
  'Drag from the center (or along an edge in “From edge” mode) · click = last size · Shift: 15° rotation · Ctrl: flip side · keys 3–9: sides':
    'Ťahajte zo stredu (alebo pozdĺž hrany v režime „Od hrany“) · kliknutie = posledná veľkosť · Shift: otočenie po 15° · Ctrl: prevrátiť stranu · klávesy 3–9: počet strán',
  'Drag across a tile to cut it straight through, edge to edge · Shift: 15° steps':
    'Ťahajte cez dlaždicu a rozrežte ju rovno od hrany k hrane · Shift: kroky po 15°',
  'Click inside a closed area to fill it with the chosen pattern':
    'Kliknite dovnútra uzavretej plochy a vyplňte ju zvoleným vzorom',
  'Click or drag across tiles to paint them · click again to recolor · ∅ swatch erases · Alt+click: pick a color':
    'Kliknutím alebo ťahaním cez dlaždice ich vyfarbíte · ďalším kliknutím prefarbíte · vzorkovník ∅ maže · Alt+klik: vybrať farbu',
  'Drag to pan · mouse wheel zooms':
    'Ťahaním posuniete pohľad · koliesko myši približuje',
  'The lines layer is locked or hidden (see Layers).':
    'Vrstva čiar je zamknutá alebo skrytá (pozri Vrstvy).',
  'About {n} tiles – too many, use a bigger tile size.':
    'Asi {n} {n|dlaždica|dlaždice|dlaždíc} – priveľa, použite väčšie dlaždice.',
  'About {n} tiles.':
    'Asi {n} {n|dlaždica|dlaždice|dlaždíc}.',
  'Load a photo first.':
    'Najprv načítajte fotku.',
  'That gives {n} tiles – use a bigger tile size.':
    'To dáva {n} {n|dlaždicu|dlaždice|dlaždíc} – použite väčšie dlaždice.',
  'Before making a mosaic from the photo':
    'Pred vytvorením mozaiky z fotky',
  'From photo':
    'Z fotky',
  'New palette “{name}” with {n} {n|color|colors}.':
    'Nová paleta „{name}“ s {n} {n|farbou|farbami|farbami}.',
  'Made a mosaic of {n} tiles from the photo.':
    'Z fotky vznikla mozaika z {n} {n|dlaždice|dlaždíc|dlaždíc}.',
  'Working…':
    'Pracujem…',
  'Make mosaic':
    'Vytvoriť mozaiku',
  'Versions are kept in this browser: every few minutes while you work, and before you open, start or restore another drawing. Restoring keeps your current drawing as a version too.':
    'Verzie sa ukladajú v tomto prehliadači: počas práce každých pár minút a tiež predtým, ako otvoríte, založíte alebo obnovíte inú kresbu. Pri obnovení sa aj aktuálna kresba uloží ako verzia.',
  'No versions yet. A version is kept every few minutes while you work, and before you open or start another drawing.':
    'Zatiaľ žiadne verzie. Verzia sa ukladá počas práce každých pár minút a predtým, ako otvoríte alebo založíte inú kresbu.',
  '{n} painted {n|area|areas}':
    '{n} {n|vyfarbená plocha|vyfarbené plochy|vyfarbených plôch}',
  'Saved by hand':
    'Uložené ručne',
  'This browser can’t copy images – use PNG to save one instead.':
    'Tento prehliadač nevie kopírovať obrázky – uložte si namiesto toho PNG.',
  'Copied the drawing as an image – paste it into the raster app or any other program.':
    'Kresba je skopírovaná ako obrázok – vložte ju do rastrovej aplikácie alebo do akéhokoľvek programu.',
  'Could not copy the image (the browser refused).':
    'Obrázok sa nedá skopírovať (prehliadač to odmietol).',
  '{n} {n|panel|panels} ({rows} × {cols}) · each printed at real size on {s} {paper} {s|sheet|sheets}.':
    '{n} {n|panel|panely|panelov} ({rows} × {cols}) · každý vytlačený v skutočnej veľkosti na {s} {s|list|listy|listov} {paper}.',
  'laying plan: {n} {n|panel|panels} ({rows} rows × {cols} columns) of {w} × {h} {unit}':
    'plán kladenia: {n} {n|panel|panely|panelov} ({rows} radov × {cols} stĺpcov) s veľkosťou {w} × {h} {unit}',
  'Panel {n} – row {row}, column {col}':
    'Panel {n} – rad {row}, stĺpec {col}',
  'Panel {n}':
    'Panel {n}',
  'Panel':
    'Panel',
  'tiles per panel and color':
    'dlaždice podľa panelov a farieb',
  'laying plan':
    'plán kladenia',
  '{c} – click to remove from the mix':
    '{c} – kliknutím odstránite zo zmesi',
  'Shift+click two or more swatches to put them in the mix.':
    'Shift+kliknite na dva alebo viac vzorkovníkov a pridajte ich do zmesi.',
  'Each tile gets one of these {n} colors at random. Shift+click swatches to change the mix.':
    'Každá dlaždica dostane náhodne jednu z týchto {n} farieb. Shift+klikom na vzorkovníky zmes zmeníte.',
  'Put at least two colors in the mix first (Shift+click swatches).':
    'Najprv dajte do zmesi aspoň dve farby (Shift+klik na vzorkovníky).',
  'Mixed the colors of {n} {n|area|areas}.':
    'Premiešané farby {n} {n|plochy|plôch|plôch}.',
  'Select painted areas first.':
    'Najprv vyberte vyfarbené plochy.',
  'Cut {n} {n|shape|shapes}. Paste with Ctrl+V – also in another page or drawing.':
    'Vystrihnuté: {n} {n|tvar|tvary|tvarov}. Vložte pomocou Ctrl+V – aj na inú stránku alebo do inej kresby.',
  'Copied {n} {n|shape|shapes}. Paste with Ctrl+V – also in another page or drawing.':
    'Skopírované: {n} {n|tvar|tvary|tvarov}. Vložte pomocou Ctrl+V – aj na inú stránku alebo do inej kresby.',
  'Pasted {n} {n|shape|shapes}.':
    'Vložené: {n} {n|tvar|tvary|tvarov}.',
  'Could not store the motifs.':
    'Motívy sa nedajú uložiť.',
  'No motifs yet. Select some shapes and save them.':
    'Zatiaľ žiadne motívy. Vyberte nejaké tvary a uložte ich.',
  '{name} – click, then click on the drawing to place it':
    '{name} – kliknite a potom kliknutím do kresby motív umiestnite',
  'Delete this motif':
    'Zmazať tento motív',
  'Delete the motif “{name}”?':
    'Zmazať motív „{name}“?',
  'Select the shapes of the motif first (Select tool).':
    'Najprv vyberte tvary motívu (nástroj Výber).',
  'Name of the motif:':
    'Názov motívu:',
  'Motif {n}':
    'Motív {n}',
  'Saved the motif “{name}”.':
    'Motív „{name}“ je uložený.',
  'This motif could not be read.':
    'Tento motív sa nedá načítať.',
  'Placed “{name}”. Click again for another one, R turns it, Esc stops.':
    'Umiestnený motív „{name}“. Ďalším kliknutím pridáte ďalší, R otáča, Esc končí.',
  'Click to place the motif · R: turn it by 15° (Shift+R: 90°) · Esc: stop':
    'Kliknutím umiestnite motív · R: otočiť o 15° (Shift+R: o 90°) · Esc: koniec',
  'There are no motifs to export yet.':
    'Zatiaľ nie sú žiadne motívy na export.',
  'Imported {n} {n|motif|motifs}.':
    'Importované: {n} {n|motív|motívy|motívov}.',
  'No motifs found in that file.':
    'V tom súbore nie sú žiadne motívy.',
  'That file is not a motif library.':
    'Ten súbor nie je knižnica motívov.',
  'Page {n}':
    'Stránka {n}',
  '{name} copy':
    '{name} – kópia',
  'Page name:':
    'Názov stránky:',
  'A project needs at least one page.':
    'Projekt musí mať aspoň jednu stránku.',
  'Delete the page “{name}”? (A copy of the project is kept in History.)':
    'Zmazať stránku „{name}“? (Kópia projektu zostane v Histórii.)',
  'Before deleting the page {name}':
    'Pred zmazaním stránky {name}',
  'Rename…':
    'Premenovať…',
  'Duplicate':
    'Duplikovať',
  'Move left':
    'Posunúť doľava',
  'Move right':
    'Posunúť doprava',
  'Delete…':
    'Zmazať…',
  'Double-click to rename':
    'Dvojklikom premenujete',
  'Switch to this page':
    'Prepnúť na túto stránku',
  'Page options':
    'Možnosti stránky',
  'Load a photo first (Photo section).':
    'Najprv načítajte fotku (sekcia Fotka na obkreslenie).',
  'The palette is empty – add colors first.':
    'Paleta je prázdna – najprv pridajte farby.',
  'Colored {n} {n|area|areas} with the closest palette colors':
    'Vyfarbené {n} {n|plocha|plochy|plôch} najbližšími farbami palety',
  '{n} already painted (left as they were)':
    '{n} už {n|bola vyfarbená|boli vyfarbené|bolo vyfarbených} (bez zmeny)',
  '{n} outside the photo':
    '{n} mimo fotky',
  'colors':
    'farby',
  'The browser blocked the print window – allow pop-ups for this page.':
    'Prehliadač zablokoval okno tlače – povoľte pre túto stránku vyskakovacie okná.',
  'Nothing to import from the raster app.':
    'Z rastrovej aplikácie nie je čo importovať.',
  'Opened {n} tiles from the raster app – your previous drawing is in History.':
    'Otvorené {n} {n|dlaždica|dlaždice|dlaždíc} z rastrovej aplikácie – predchádzajúca kresba je v Histórii.',
  '<b>{n}</b> painted {n|area|areas} in <b>{c}</b> {c|color|colors}':
    '<b>{n}</b> {n|vyfarbená plocha|vyfarbené plochy|vyfarbených plôch} v <b>{c}</b> {c|farbe|farbách|farbách}',
  '<b>{n}</b> not painted yet':
    '<b>{n}</b> ešte nevyfarbené',
  'everything is painted':
    'všetko je vyfarbené',
  'page {w} × {h} {unit}':
    'stránka {w} × {h} {unit}',
  'Color':
    'Farba',
  'Areas':
    'Plochy',
  'Total area':
    'Celková plocha',
  'Share':
    'Zdieľať',
  'Pieces of the size set above, plus waste':
    'Kusy s veľkosťou nastavenou vyššie, vrátane odpadu',
  'Pieces to buy':
    'Kusov na kúpu',
  'Replace with':
    'Nahradiť za',
  'Erase':
    'Zmazať',
  'Nothing is painted yet. Use the paint bucket, or “Color tiles from photo”.':
    'Zatiaľ nie je nič vyfarbené. Použite vedro alebo „Vyfarbiť dlaždice podľa fotky“.',
  'Recolored {n} {n|area|areas}.':
    'Prefarbené: {n} {n|plocha|plochy|plôch}.',
  'Erased {n} {n|area|areas}.':
    'Zmazané: {n} {n|plocha|plochy|plôch}.',
  'Colors that may look alike':
    'Farby, ktoré môžu vyzerať podobne',
  '{a} and {b} {how}':
    '{a} a {b} {how}',
  'The link would be {kb} KB – too long. Share the file instead, or leave out the photo.':
    'Odkaz by mal {kb} KB – to je priveľa. Zdieľajte radšej súbor alebo vynechajte fotku.',
  'The link is {kb} KB – long links can get cut off in some messengers; sharing the file is safer. Anyone with it can view the mosaic and make their own copy.':
    'Odkaz má {kb} KB – dlhé odkazy niektoré chatovacie aplikácie skracujú; bezpečnejšie je zdieľať súbor. Ktokoľvek s odkazom si mozaiku pozrie a môže si urobiť vlastnú kópiu.',
  'The link is {kb} KB. Anyone with it can view the mosaic and make their own copy.':
    'Odkaz má {kb} KB. Ktokoľvek s odkazom si mozaiku pozrie a môže si urobiť vlastnú kópiu.',
  'Sharing failed.':
    'Zdieľanie zlyhalo.',
  'Link copied.':
    'Odkaz je skopírovaný.',
  'This share link is damaged or incomplete.':
    'Tento odkaz je poškodený alebo neúplný.',
  'Before opening a shared mosaic':
    'Pred otvorením zdieľanej mozaiky',
  'This is now your own copy – it is saved in this browser like any drawing.':
    'Teraz je to vaša vlastná kópia – ukladá sa v tomto prehliadači ako každá kresba.',
  'Normal colors':
    'Bežné farby',
  'Black & white':
    'Čiernobielo',
  'Red-blind (protanopia)':
    'Necitlivosť na červenú (protanopia)',
  'Green-blind (deuteranopia)':
    'Necitlivosť na zelenú (deuteranopia)',
  'Blue-blind (tritanopia)':
    'Necitlivosť na modrú (tritanopia)',
  'look almost the same':
    'vyzerajú takmer rovnako',
  'in black & white':
    'čiernobielo',
  'for red-blind viewers':
    'pre ľudí necitlivých na červenú',
  'for green-blind viewers':
    'pre ľudí necitlivých na zelenú',
  'for blue-blind viewers':
    'pre ľudí necitlivých na modrú',
  'look alike {who}':
    'vyzerajú podobne {who}',
  '{n} {n|tile blends|tiles blend} into a neighbour of another color.':
    '{n} {n|dlaždica splýva|dlaždice splývajú|dlaždíc splýva} so susednou dlaždicou inej farby.',
  '{n} {n|tile blends|tiles blend} into a neighbour of another color (in this view).':
    '{n} {n|dlaždica splýva|dlaždice splývajú|dlaždíc splýva} so susednou dlaždicou inej farby (v tomto zobrazení).',
  'No tile blends into its neighbours.':
    'Žiadna dlaždica nesplýva so susednými.',
  'Sheet {sheet} – row {row}, column {col} of {cols} · blue strips are covered by the next sheet':
    'List {sheet} – rad {row}, stĺpec {col} z {cols} · modré pruhy prekryje ďalší list',
  'One {paper} sheet ({orientation}), at {pct} % of the real size.':
    'Jeden list {paper} ({orientation}), {pct} % skutočnej veľkosti.',
  'One {paper} sheet ({orientation}) at real size.':
    'Jeden list {paper} ({orientation}) v skutočnej veľkosti.',
  '{n} {paper} {n|sheet|sheets} ({orientation}, {rows} × {cols}, overlapping {overlap} mm) at real size.':
    '{n} {n|list|listy|listov} {paper} ({orientation}, {rows} × {cols}, s prekrytím {overlap} mm) v skutočnej veľkosti.',
  '{n} sheets ({rows} × {cols}), real size {w} × {h} cm':
    '{n} listov ({rows} × {cols}), skutočná veľkosť {w} × {h} cm',
  'The picture has many colors: it is snapped to the current palette (use “Reduce to palette” to see the result first).':
    'Obrázok má veľa farieb: prevedie sa na aktuálnu paletu (výsledok si môžete najprv pozrieť cez „Previesť na paletu“).',
  'The picture has many colors: it is snapped to 8 colors suggested from it.':
    'Obrázok má veľa farieb: prevedie sa na 8 farieb navrhnutých z neho.',
  'Images':
    'Obrázky',
  'PNG image':
    'Obrázok PNG',
  'Discard unsaved changes to the current image?\n(Save it first if you want to keep it.)':
    'Zahodiť neuložené zmeny v aktuálnom obrázku?\n(Ak si ho chcete ponechať, najprv ho uložte.)',
  'Could not read {name} as an image.':
    'Súbor {name} sa nedá načítať ako obrázok.',
  'Opened {name} ({w} × {h} px).':
    'Otvorené: {name} ({w} × {h} px).',
  'Size of the new image in pixels (width × height):':
    'Veľkosť nového obrázka v pixeloch (šírka × výška):',
  'Enter a size like 800 × 600 (at most {max} px a side).':
    'Zadajte veľkosť ako 800 × 600 (najviac {max} px na stranu).',
  'Before starting a new image':
    'Pred založením nového obrázka',
  'That version could not be read.':
    'Túto verziu sa nedá načítať.',
  'Export failed.':
    'Export zlyhal.',
  'Autosave failed – remember to save your image.':
    'Automatické ukladanie zlyhalo – nezabudnite obrázok uložiť.',
  'The clipboard has no image or color codes.':
    'V schránke nie je obrázok ani kódy farieb.',
  'Versions are kept in this browser: every few minutes while you work, and before you open, start or restore another image. Restoring keeps your current image as a version too.':
    'Verzie sa ukladajú v tomto prehliadači: počas práce každých pár minút a tiež predtým, ako otvoríte, založíte alebo obnovíte iný obrázok. Pri obnovení sa aj aktuálny obrázok uloží ako verzia.',
  'No versions yet. A version is kept every few minutes while you work, and before you open or start another image.':
    'Zatiaľ žiadne verzie. Verzia sa ukladá počas práce každých pár minút a predtým, ako otvoríte alebo založíte iný obrázok.',
  'The palette is empty – add colors, or let the mosaic suggest some.':
    'Paleta je prázdna – pridajte farby alebo nechajte mozaiku nejaké navrhnúť.',
  'There is nothing to make a mosaic from (the area is transparent).':
    'Nie je z čoho urobiť mozaiku (plocha je priehľadná).',
  'From picture':
    'Z obrázka',
  'Made {n} {n|tile|tiles} in {c} {c|color|colors}.':
    'Vytvorené {n} {n|dlaždica|dlaždice|dlaždíc} v {c} {c|farbe|farbách|farbách}.',
  'The palette is empty.':
    'Paleta je prázdna.',
  'Every pixel now has a palette color: {n} {n|pixel|pixels} in {c} {c|color|colors}.':
    'Každý pixel má teraz farbu z palety: {n} {n|pixel|pixely|pixelov} v {c} {c|farbe|farbách|farbách}.',
  'At most about {n} tiles in the selection – bigger ones where the picture is calm.':
    'Najviac asi {n} {n|dlaždica|dlaždice|dlaždíc} vo výbere – kde je obrázok pokojný, budú väčšie.',
  'At most about {n} tiles – bigger ones where the picture is calm.':
    'Najviac asi {n} {n|dlaždica|dlaždice|dlaždíc} – kde je obrázok pokojný, budú väčšie.',
  'About {n} tiles in the selection.':
    'Asi {n} {n|dlaždica|dlaždice|dlaždíc} vo výbere.',
  'Turn on “Fill” or “Outline” for polygons.':
    'Pri mnohouholníkoch zapnite „Výplň“ alebo „Obrys“.',
  'Picked “transparent”.':
    'Vybraná „priehľadná“.',
  'Picked {c} (not in the palette – add it with “From image”).':
    'Vybraná farba {c} (nie je v palete – pridajte ju tlačidlom „Z obrázka“).',
  '{n} {n|pixel|pixels}':
    '{n} {n|pixel|pixely|pixelov}',
  'paint color':
    'farba maľovania',
  'outline color':
    'farba obrysu',
  'Transparent – paints and fills transparent pixels':
    'Priehľadná – maľuje a vypĺňa priehľadnými pixelmi',
  'Recolored {n} {n|pixel|pixels}.':
    'Prefarbené: {n} {n|pixel|pixely|pixelov}.',
  'Nothing to paste – or the browser didn’t allow reading the clipboard (try Ctrl+V).':
    'Nie je čo vložiť – alebo prehliadač nepovolil čítanie schránky (skúste Ctrl+V).',
  'Enter a size from 1 to {max} px.':
    'Zadajte veľkosť od 1 do {max} px.',
  'This picture has {n} pieces – too many to number. Make a mosaic or reduce it to the palette first.':
    'Obrázok má {n} {n|dielik|dieliky|dielikov} – to je na číslovanie priveľa. Najprv z neho urobte mozaiku alebo ho preveďte na paletu.',
  '{n} {n|piece|pieces}':
    '{n} {n|dielik|dieliky|dielikov}',
  '{n} {n|piece|pieces} in {c} {c|color|colors} · {w} × {h} px':
    '{n} {n|dielik|dieliky|dielikov} v {c} {c|farbe|farbách|farbách} · {w} × {h} px',
  'Nothing is painted yet.':
    'Zatiaľ nie je nič vyfarbené.',
  '{w} × {h} mm · {k} mm per pixel':
    '{w} × {h} mm · {k} mm na pixel',
  'Pieces':
    'Dieliky',
  'Pixels':
    'Pixely',
  'Area':
    'Plocha',
  'transparent':
    'priehľadná',
  '({w} × {h} px, not placed yet)':
    '({w} × {h} px, ešte neumiestnené)',
  'Cut the selection – paste it here, into the vector app or any other program.':
    'Výber je vystrihnutý – vložte ho sem, do vektorovej aplikácie alebo do akéhokoľvek programu.',
  'Cut the image – paste it here, into the vector app or any other program.':
    'Obrázok je vystrihnutý – vložte ho sem, do vektorovej aplikácie alebo do akéhokoľvek programu.',
  'Copied the selection – paste it here, into the vector app or any other program.':
    'Výber je skopírovaný – vložte ho sem, do vektorovej aplikácie alebo do akéhokoľvek programu.',
  'Copied the image – paste it here, into the vector app or any other program.':
    'Obrázok je skopírovaný – vložte ho sem, do vektorovej aplikácie alebo do akéhokoľvek programu.',
  'Cut the selection (this browser keeps it for pasting here only).':
    'Výber je vystrihnutý (tento prehliadač ho uchová len na vloženie sem).',
  'Cut the image (this browser keeps it for pasting here only).':
    'Obrázok je vystrihnutý (tento prehliadač ho uchová len na vloženie sem).',
  'Copied the selection (this browser keeps it for pasting here only).':
    'Výber je skopírovaný (tento prehliadač ho uchová len na vloženie sem).',
  'Copied the image (this browser keeps it for pasting here only).':
    'Obrázok je skopírovaný (tento prehliadač ho uchová len na vloženie sem).',
  'Select the part to keep first.':
    'Najprv vyberte časť, ktorú chcete ponechať.',
  'Could not read the pasted image.':
    'Vložený obrázok sa nedá načítať.',
  'The pasted image ({w} × {h}) is bigger than this one ({W} × {H}). Enlarge the canvas to fit it?':
    'Vložený obrázok ({w} × {h}) je väčší ako tento ({W} × {H}). Zväčšiť plátno, aby sa zmestil?',
  'Pasted {w} × {h} px – drag it into place, then press Enter (or click outside it).':
    'Vložené {w} × {h} px – presuňte na miesto a stlačte Enter (alebo kliknite mimo).',
  'The link would be {kb} KB – too long. Share the file instead (or make the image smaller).':
    'Odkaz by mal {kb} KB – to je priveľa. Zdieľajte radšej súbor (alebo obrázok zmenšite).',
  'The link is {kb} KB – long links can get cut off in some messengers; sharing the file is safer. Anyone with it can view the image and make their own copy.':
    'Odkaz má {kb} KB – dlhé odkazy niektoré chatovacie aplikácie skracujú; bezpečnejšie je zdieľať súbor. Ktokoľvek s odkazom si obrázok pozrie a môže si urobiť vlastnú kópiu.',
  'The link is {kb} KB. Anyone with it can view the image and make their own copy.':
    'Odkaz má {kb} KB. Ktokoľvek s odkazom si obrázok pozrie a môže si urobiť vlastnú kópiu.',
  'Before opening a shared image':
    'Pred otvorením zdieľaného obrázka',
  'This is now your own copy – it is saved in this browser like any image.':
    'Teraz je to vaša vlastná kópia – ukladá sa v tomto prehliadači ako každý obrázok.',
  'Drag to select · drag inside the selection to move it (Alt: a copy) · Enter places it · Ctrl+C / X / V copy, cut, paste':
    'Ťahaním vyberiete · ťahaním vo výbere ho posuniete (Alt: kópiu) · Enter ho umiestni · Ctrl+C / X / V kopírovať, vystrihnúť, vložiť',
  'Drag to paint · Shift: straight line · [ ] size · Shift+B: tip · Alt+click: pick a color':
    'Ťahaním maľujete · Shift: rovná čiara · [ ] veľkosť · Shift+B: hrot · Alt+klik: vybrať farbu',
  'Hard pixels in exact colors · Shift: straight line · [ ] size · Alt+click: pick a color':
    'Ostré pixely v presných farbách · Shift: rovná čiara · [ ] veľkosť · Alt+klik: vybrať farbu',
  'Drag to erase to transparent · Shift: straight line · [ ] size':
    'Ťahaním mažete do priehľadnosti · Shift: rovná čiara · [ ] veľkosť',
  'Drag a line · Shift: 15° steps':
    'Ťahajte čiaru · Shift: kroky po 15°',
  'Drag from the center · Shift: 15° rotation · keys 3–9: sides':
    'Ťahajte zo stredu · Shift: otočenie po 15° · klávesy 3–9: počet strán',
  'Click to fill the area of similar color · Alt+click: pick a color':
    'Kliknutím vyplníte plochu podobnej farby · Alt+klik: vybrať farbu',
  'Click to take a color from the image':
    'Kliknutím vezmete farbu z obrázka',
  'No grout – every piece is a tile':
    'Bez škár – každý dielik je dlaždica',
  '{n} {n|tile|tiles} at {w} × {h} mm – too many: make a mosaic or reduce the picture to the palette first.':
    '{n} {n|dlaždica|dlaždice|dlaždíc} na {w} × {h} mm – priveľa: najprv urobte mozaiku alebo preveďte obrázok na paletu.',
  '{n} {n|tile|tiles} at {w} × {h} mm.':
    '{n} {n|dlaždica|dlaždice|dlaždíc} na {w} × {h} mm.',
  'Could not hand the tiles over (browser storage unavailable).':
    'Dlaždice sa nedajú odovzdať (úložisko prehliadača nie je dostupné).',
  '3D print':
    '3D tlač',
  'Close':
    'Zavrieť',
  'A model where every color stands at its own height. Print it with one nozzle and change the filament at the layers listed below – each tile’s top then shows its color. The 3MF file already contains the filament changes for PrusaSlicer; for other slicers, the plan lists them.':
    'Model, v ktorom má každá farba svoju výšku. Vytlačte ho jednou tryskou a vo vrstvách uvedených nižšie vymeňte filament – horná plocha každej dlaždice potom má svoju farbu. Súbor 3MF už výmeny filamentu obsahuje pre PrusaSlicer; pre iné slicery ich nájdete v pláne.',
  'Size':
    'Veľkosť',
  'Size of the model’s smallest step – about your nozzle width':
    'Veľkosť najmenšieho kroku modelu – zhruba šírka vašej trysky',
  'Detail':
    'Detail',
  'Layer height':
    'Výška vrstvy',
  'How many layers each color gets – more layers cover the color below better':
    'Koľko vrstiev dostane každá farba – viac vrstiev lepšie prekryje farbu pod ňou',
  'Layers per color':
    'Vrstiev na farbu',
  'A plate under everything, printed in the first color. 0: unpainted parts are left open':
    'Doska pod všetkým, tlačená prvou farbou. 0: nevyfarbené miesta zostanú otvorené',
  'Base layers':
    'Vrstiev základu',
  'Top view of the model':
    'Pohľad na model zhora',
  'Print order (bottom first):':
    'Poradie tlače (odspodu):',
  'Lighter colors lower: a darker layer covers a lighter one well. Lines (grout) stay at the bottom':
    'Svetlejšie farby nižšie: tmavšia vrstva svetlejšiu dobre prekryje. Čiary (škáry) zostávajú dole',
  'Light → dark':
    'Svetlé → tmavé',
  'Dark → light':
    'Tmavé → svetlé',
  'Which filament to load at which layer, as a text file':
    'Ktorý filament v ktorej vrstve založiť, ako textový súbor',
  'Plan':
    'Plán',
  'Just the shape – add the filament changes from the plan in your slicer':
    'Len tvar – výmeny filamentu podľa plánu pridajte v sliceri',
  'The model, with the filament changes for PrusaSlicer':
    'Model aj s výmenami filamentu pre PrusaSlicer',
  'Download 3MF':
    'Stiahnuť 3MF',
  '{n} colors make a tall print with many filament changes – reduce the colors first (Raster: “Reduce to palette”).':
    '{n} {n|farba dáva|farby dávajú|farieb dáva} vysoký výtlačok s mnohými výmenami filamentu – najprv znížte počet farieb (Raster: „Previesť na paletu“).',
  'Detail lowered to {d} mm for this size.':
    'Detail znížený na {d} mm kvôli tejto veľkosti.',
  'lines':
    'čiary',
  'Print earlier (lower)':
    'Tlačiť skôr (nižšie)',
  'Print later (higher)':
    'Tlačiť neskôr (vyššie)',
  '{share} % · layers {from}–{to}':
    '{share} % · vrstvy {from}–{to}',
  '{share} % · layers {from}–{to} · change at Z {z}':
    '{share} % · vrstvy {from}–{to} · výmena vo výške Z {z}',
  '{n} {n|color|colors} · height {h} mm ({layers} {layers|layer|layers}) · {c} filament {c|change|changes}':
    '{n} {n|farba|farby|farieb} · výška {h} mm ({layers} {layers|vrstva|vrstvy|vrstiev}) · {c} {c|výmena|výmeny|výmen} filamentu',
  'unpainted parts stay at the base ({h} mm)':
    'nevyfarbené miesta zostanú vo výške základu ({h} mm)',
  'unpainted parts are left open':
    'nevyfarbené miesta zostanú otvorené',
  'Mosaic Paint – 3D print plan for {name}.3mf / {name}.stl':
    'Mosaic Paint – plán 3D tlače pre {name}.3mf / {name}.stl',
  'Size {w} × {h} mm · layer height {lh} mm · {lpc} layers per color · base {base} layers':
    'Veľkosť {w} × {h} mm · výška vrstvy {lh} mm · {lpc} vrstiev na farbu · základ {base} vrstiev',
  'Total height {total} mm ({layers} layers). Set the slicer’s first layer height to {lh} mm too.':
    'Celková výška {total} mm ({layers} vrstiev). Výšku prvej vrstvy v sliceri nastavte tiež na {lh} mm.',
  'Start with {color} – layers {from}–{to} (base plate included)':
    'Začnite farbou {color} – vrstvy {from}–{to} (vrátane základnej dosky)',
  'Start with {color} – layers {from}–{to}':
    'Začnite farbou {color} – vrstvy {from}–{to}',
  'Layer {layer} (Z {z} mm): change to {color} – layers {from}–{to}':
    'Vrstva {layer} (Z {z} mm): vymeňte za {color} – vrstvy {from}–{to}',
  'PrusaSlicer: the 3MF file already contains these changes – open it and check the layer slider.':
    'PrusaSlicer: súbor 3MF už tieto výmeny obsahuje – otvorte ho a skontrolujte posuvník vrstiev.',
  'Other slicers (they read only the shape from the 3MF or STL) – add the changes by hand:':
    'Iné slicery (z 3MF alebo STL načítajú len tvar) – výmeny pridajte ručne:',
  '- PrusaSlicer, Bambu Studio, OrcaSlicer: in the preview, move the layer slider to each Z above and click “+” (Add color change, M600).':
    '- PrusaSlicer, Bambu Studio, OrcaSlicer: v náhľade posuňte posuvník vrstiev na každú výšku Z vyššie a kliknite na „+“ (Pridať zmenu farby, M600).',
  '- Cura: Extensions › Post Processing › Modify G-Code › “Filament Change” at each layer number above.':
    '- Cura: Rozšírenia › Postprocessing › Upraviť G-kód › „Filament Change“ pri každom čísle vrstvy vyššie.',
  '- Multi-material printers (AMS, MMU): the same changes work; or assign the filaments to the color changes in the slicer.':
    '- Tlačiarne pre viac materiálov (AMS, MMU): fungujú rovnaké výmeny; alebo priraďte filamenty k zmenám farby v sliceri.',
  'Could not read the picture.':
    'Obrázok sa nedá načítať.',
  'Saved {name}.3mf ({n} triangles; PrusaSlicer reads its {c} filament {c|change|changes}, other slicers need the plan).':
    'Uložené {name}.3mf ({n} trojuholníkov; PrusaSlicer načíta {c} {c|výmenu|výmeny|výmen} filamentu, iné slicery potrebujú plán).',
  'Saved {name}.stl ({n} triangles). Add the filament changes from the plan in your slicer.':
    'Uložené {name}.stl ({n} trojuholníkov). Výmeny filamentu podľa plánu pridajte v sliceri.',
  'Reading the picture…':
    'Načítavam obrázok…',
  'History':
    'História',
  'Save a version now':
    'Uložiť verziu teraz',
  'Version history needs browser storage (IndexedDB), which is not available here.':
    'História verzií potrebuje úložisko prehliadača (IndexedDB), ktoré tu nie je dostupné.',
  'Restore':
    'Obnoviť',
  'Version saved.':
    'Verzia je uložená.',
  'Could not save a version (browser storage unavailable).':
    'Verziu sa nedá uložiť (úložisko prehliadača nie je dostupné).',
  'used by {what}':
    'použité: {what}',
  'Click: {fill} · Right-click: {stroke} · Double-click: edit':
    'Klik: {fill} · Pravý klik: {stroke} · Dvojklik: upraviť',
  'Remove from palette':
    'Odstrániť z palety',
  'Edit color (hex or any CSS color).\nThe drawing is recolored too.':
    'Upraviť farbu (hex alebo akákoľvek farba CSS).\nPrefarbí sa aj kresba.',
  'Not a valid color: {v}':
    'Neplatná farba: {v}',
  'Paste a color code (or several) into the box, then press Enter.':
    'Vložte do poľa kód farby (alebo niekoľko) a stlačte Enter.',
  'No color found in: {text}':
    'Nenašla sa žiadna farba v: {text}',
  'Added {n} {n|color|colors}.':
    'Pridané: {n} {n|farba|farby|farieb}.',
  'Already in the palette.':
    'Už je v palete.',
  'Added {n} {n|color|colors} from the clipboard.':
    'Zo schránky pridané: {n} {n|farba|farby|farieb}.',
  'Those colors are already in the palette.':
    'Tieto farby už v palete sú.',
  'Name of the new palette:':
    'Názov novej palety:',
  'Palette':
    'Paleta',
  'Created “{name}”. Paste colors to fill it.':
    'Vytvorená paleta „{name}“. Naplňte ju vložením farieb.',
  'Rename palette:':
    'Premenovať paletu:',
  'Delete the palette “{name}”? (The drawing is not changed.)':
    'Zmazať paletu „{name}“? (Kresba sa nezmení.)',
  'Added {n} {n|color|colors} from the drawing.':
    'Z kresby pridané: {n} {n|farba|farby|farieb}.',
  'No new colors in the drawing.':
    'V kresbe nie sú žiadne nové farby.',
  'Remove all colors from this palette? (The drawing is not changed.)':
    'Odstrániť z tejto palety všetky farby? (Kresba sa nezmení.)',
  'Imported {n} {n|color|colors}.':
    'Importované: {n} {n|farba|farby|farieb}.',
  'No new colors found in {name}':
    'V súbore {name} nie sú žiadne nové farby',
  'Installed – Mosaic Paint now works offline too.':
    'Nainštalované – Mosaic Paint teraz funguje aj offline.',
  'Simple':
    'Jednoduchý',
  'Expert':
    'Expert',
  'New':
    'Nový',
  'Open…':
    'Otvoriť…',
  'Save':
    'Uložiť',
  'Save as…':
    'Uložiť ako…',
  'Copy image':
    'Kopírovať obrázok',
  'Print…':
    'Tlač…',
  'Plan…':
    'Plán…',
  'Report':
    'Prehľad',
  'Contrast':
    'Kontrast',
  'Share of area':
    'Podiel plochy',
  'Install app':
    'Nainštalovať aplikáciu',
  'You are looking at a shared mosaic.':
    'Prezeráte si zdieľanú mozaiku.',
  'Make my own copy':
    'Urobiť si vlastnú kópiu',
  'Back to my drawing':
    'Späť k mojej kresbe',
  'Remove last corner':
    'Odstrániť posledný roh',
  'Cancel':
    'Zrušiť',
  'Colors':
    'Farby',
  'Fill':
    'Výplň',
  'Stroke':
    'Obrys',
  'Width':
    'Šírka',
  'Add color':
    'Pridať farbu',
  'Import…':
    'Importovať…',
  'From drawing':
    'Z kresby',
  'Export':
    'Exportovať',
  'Clear':
    'Vymazať',
  'Click a swatch = fill · right-click = stroke · double-click = edit (also recolors the drawing) · Shift+click = add to the color mix. Ctrl+V on the canvas adds copied colors.':
    'Klik na vzorkovník = výplň · pravý klik = obrys · dvojklik = upraviť (prefarbí aj kresbu) · Shift+klik = pridať do zmesi farieb. Ctrl+V na plátne pridá skopírované farby.',
  'Line':
    'Čiara',
  'Chain lines (next line starts at the last end)':
    'Nadväzovať čiary (ďalšia čiara začne na konci predchádzajúcej)',
  'Free polygon':
    'Voľný mnohouholník',
  'Click each corner. Click the first corner again, double-click or press Enter to close it.':
    'Kliknite na každý roh. Tvar uzavriete kliknutím na prvý roh, dvojklikom alebo klávesom Enter.',
  'Fill new shapes with the fill color':
    'Nové tvary vyplniť farbou výplne',
  'Regular polygon':
    'Pravidelný mnohouholník',
  'Sides':
    'Strany',
  'From center':
    'Zo stredu',
  'From edge':
    'Od hrany',
  'Knife':
    'Nôž',
  'Press inside a tile and drag in the direction of the cut. The tile is cut straight across, from edge to edge.':
    'Stlačte vnútri dlaždice a ťahajte v smere rezu. Dlaždica sa rozreže rovno od hrany k hrane.',
  'Pattern':
    'Vzor',
  'Angle':
    'Uhol',
  'Rows':
    'Rady',
  'Fill whole page':
    'Vyplniť celú stránku',
  'Click inside a closed area to fill it with tiles. Painted areas keep their color in every new tile. “Rows following the outline” lays rows along the area’s edge and around shapes inside it (Rows 0 = fill it).':
    'Kliknite dovnútra uzavretej plochy a vyplňte ju dlaždicami. Vyfarbené plochy si farbu ponechajú v každej novej dlaždici. „Rady pozdĺž obrysu“ kladú rady pozdĺž okraja plochy a okolo tvarov vnútri nej (Rady 0 = vyplniť celú).',
  'Paint bucket':
    'Vedro',
  'Click inside any closed area, or drag across many tiles. Click a painted area again to recolor it. The ∅ swatch erases. Alt+click picks a color.':
    'Kliknite do ľubovoľnej uzavretej plochy alebo ťahajte cez viac dlaždíc. Ďalším kliknutím vyfarbenú plochu prefarbíte. Vzorkovník ∅ maže. Alt+klik vyberie farbu.',
  'Mix colors (a random one per tile)':
    'Miešať farby (každá dlaždica náhodnú)',
  'Avoid the same color next to itself':
    'Nedávať rovnakú farbu vedľa seba',
  'Close gaps up to':
    'Uzatvárať medzery do',
  'Photo to trace':
    'Fotka na obkreslenie',
  'Opacity':
    'Krytie',
  'Show':
    'Zobraziť',
  'Locked':
    'Zamknuté',
  'Fit to page':
    'Prispôsobiť stránke',
  'Remove':
    'Odstrániť',
  'Keep the photo in saved files':
    'Ukladať fotku do súborov',
  'Make a mosaic from the photo…':
    'Vytvoriť mozaiku z fotky…',
  'Color my tiles from the photo':
    'Vyfarbiť moje dlaždice podľa fotky',
  'Only tiles that aren’t painted yet':
    'Len dlaždice, ktoré ešte nie sú vyfarbené',
  'Each tile gets the palette color closest to the photo underneath it. Draw the tile lines first.':
    'Každá dlaždica dostane farbu z palety najbližšiu fotke pod ňou. Najprv nakreslite čiary dlaždíc.',
  'Grout preview':
    'Náhľad škár',
  'Preview':
    'Náhľad',
  'Apply to all lines':
    'Použiť na všetky čiary',
  'Motifs':
    'Motívy',
  'Save selection…':
    'Uložiť výber…',
  'Click a motif, then click on the drawing to place it (R turns it, Esc stops). Ctrl+C / Ctrl+X / Ctrl+V copy shapes between pages, drawings and browser tabs.':
    'Kliknite na motív a potom kliknutím do kresby ho umiestnite (R otáča, Esc končí). Ctrl+C / Ctrl+X / Ctrl+V kopírujú tvary medzi stránkami, kresbami aj kartami prehliadača.',
  'Symmetry':
    'Symetria',
  'Off':
    'Vypnuté',
  'Mirror left ↔ right':
    'Zrkadliť vľavo ↔ vpravo',
  'Mirror top ↕ bottom':
    'Zrkadliť hore ↕ dole',
  'Mirror both ways':
    'Zrkadliť oboma smermi',
  'Rotate around center':
    'Otáčať okolo stredu',
  'Copies':
    'Kópie',
  'also mirrored':
    'aj zrkadlovo',
  'Pick center':
    'Vybrať stred',
  'Page center':
    'Stred stránky',
  'Lines, polygons, knife cuts and painting are repeated around the guides.':
    'Čiary, mnohouholníky, rezy nožom aj vyfarbovanie sa opakujú okolo vodidiel.',
  'Layers':
    'Vrstvy',
  'Lines & shapes':
    'Čiary a tvary',
  'Painted areas':
    'Vyfarbené plochy',
  'Photo':
    'Fotka',
  'Lock the lines while painting so they can’t be moved by accident.':
    'Pri vyfarbovaní čiary zamknite, aby sa omylom neposunuli.',
  'Snapping':
    'Prichytávanie',
  'Snap to points & lines':
    'Prichytávať k bodom a čiaram',
  'Shared corners move together':
    'Spoločné rohy sa posúvajú spolu',
  'Page edge counts as a line':
    'Okraj stránky sa počíta ako čiara',
  'Grid, size':
    'Mriežka, veľkosť',
  'Snaps to ends & corners ▢, crossings ✕, midpoints △, anywhere along a line ◇, centers ○. Hold Alt to place freely.':
    'Prichytáva ku koncom a rohom ▢, priesečníkom ✕, stredom úsečiek △, kamkoľvek na čiaru ◇ a stredom ○. So stlačeným Alt umiestňujete voľne.',
  'Selection':
    'Výber',
  'Radius':
    'Polomer',
  'Rotation°':
    'Otočenie°',
  'Line width':
    'Šírka čiary',
  'Delete':
    'Zmazať',
  'To front':
    'Dopredu',
  'To back':
    'Dozadu',
  'Mix colors':
    'Premiešať farby',
  'Page':
    'Stránka',
  'Apply':
    'Použiť',
  'Background':
    'Pozadie',
  'Show rulers':
    'Zobraziť pravítka',
  'Keyboard & mouse':
    'Klávesnica a myš',
  'Select, Line, Free polygon, Polygon, Ellipse, Curve, Pattern, Bucket, Pan':
    'Výber, Čiara, Voľný mnohouholník, Mnohouholník, Elipsa, Krivka, Vzor, Vedro, Posun',
  'Polygon sides':
    'Počet strán mnohouholníka',
  'Toggle snapping':
    'Zapnúť / vypnúť prichytávanie',
  'Alt':
    'Alt',
  'Draw / drag without snapping; detach a shared corner; Alt+click with the bucket picks a color':
    'Kresliť / ťahať bez prichytávania; oddeliť spoločný roh; Alt+klik vedrom vyberie farbu',
  'Shift':
    'Shift',
  '15° steps; add to selection':
    'Kroky po 15°; pridať k výberu',
  'Ctrl (polygon tool)':
    'Ctrl (nástroj mnohouholník)',
  'Flip side when drawing from an edge':
    'Pri kreslení od hrany prevrátiť stranu',
  'Ctrl + drag handle':
    'Ctrl + ťahanie úchytu',
  'Freely move a polygon corner (it stops being regular)':
    'Voľne posunúť roh mnohouholníka (prestane byť pravidelný)',
  'Enter / Esc':
    'Enter / Esc',
  'Finish / cancel the current shape':
    'Dokončiť / zrušiť rozkreslený tvar',
  'Del':
    'Del',
  'Delete selection (or the last corner of a free polygon)':
    'Zmazať výber (alebo posledný roh voľného mnohouholníka)',
  'Arrows':
    'Šípky',
  'Nudge (Shift = ×10)':
    'Posunúť (Shift = ×10)',
  'Undo / redo':
    'Späť / znova',
  'Copy, cut, paste shapes (also between pages and drawings). Ctrl+C with nothing selected copies the drawing as an image; pasting an image makes it the photo to trace':
    'Kopírovať, vystrihnúť, vložiť tvary (aj medzi stránkami a kresbami). Ctrl+C bez výberu skopíruje kresbu ako obrázok; vložený obrázok sa stane fotkou na obkreslenie',
  'Duplicate, select all':
    'Duplikovať, vybrať všetko',
  'Wheel, Space+drag':
    'Koliesko, medzerník+ťahanie',
  'Zoom, pan (two fingers on touch screens)':
    'Priblíženie, posun (na dotykových displejoch dvoma prstami)',
  'Fit page':
    'Celá stránka',
  '＋ Page':
    '＋ Stránka',
  'Colors & shopping list':
    'Farby a nákupný zoznam',
  'Piece size':
    'Veľkosť kusu',
  'Waste':
    'Odpad',
  '“Replace with” recolors every area of that color.':
    '„Nahradiť za“ prefarbí všetky plochy tej farby.',
  'Download CSV':
    'Stiahnuť CSV',
  'Print template':
    'Tlačová šablóna',
  'Opens a print page to use as a cutting or laying template.':
    'Otvorí stránku na tlač, ktorú použijete ako šablónu na rezanie alebo kladenie.',
  'Paper':
    'Papier',
  'Letter':
    'Letter',
  'Tabloid (11×17 in)':
    'Tabloid (11×17 palcov)',
  'Real size (split across several sheets if needed)':
    'Skutočná veľkosť (v prípade potreby na viac listov)',
  'Fit on one sheet':
    'Na jeden list',
  'In color':
    'Farebne',
  'In color, with color numbers':
    'Farebne, s číslami farieb',
  'Outlines with color numbers (paint by number)':
    'Obrysy s číslami farieb (maľovanka podľa čísel)',
  'Add a page with the color legend':
    'Pridať stránku s legendou farieb',
  'Mosaic from photo':
    'Mozaika z fotky',
  'Lays out tiles over the whole page and gives each tile the color of the photo underneath it.':
    'Rozloží dlaždice po celej stránke a každej dá farbu fotky pod ňou.',
  'First load a photo:':
    'Najprv načítajte fotku:',
  'Tiles':
    'Dlaždice',
  'Smaller tiles where the photo has detail':
    'Menšie dlaždice tam, kde má fotka detaily',
  'Use the current palette':
    'Použiť aktuálnu paletu',
  'Suggest':
    'Navrhnúť',
  'colors from the photo (new palette)':
    'farieb z fotky (nová paleta)',
  'Replace the current drawing (it is kept in History)':
    'Nahradiť aktuálnu kresbu (zostane v Histórii)',
  'Laying plan':
    'Plán kladenia',
  'Splits the mosaic into numbered panels – the size of your work surface or of the mesh sheets you lay the tiles on. The print has an overview, every panel at real size and the number of tiles of each color per panel.':
    'Rozdelí mozaiku na očíslované panely – s veľkosťou vašej pracovnej plochy alebo sietí, na ktoré dlaždice kladiete. Výtlačok obsahuje prehľad, každý panel v skutočnej veľkosti a počet dlaždíc každej farby v paneli.',
  'Panel size':
    'Veľkosť panelu',
  'Tabloid':
    'Tabloid',
  'Color numbers on the tiles':
    'Čísla farieb na dlaždiciach',
  'Show the panels on the drawing':
    'Zobraziť panely v kresbe',
  'The whole drawing is packed into the link itself – nothing is uploaded. Whoever opens it sees the mosaic and can make their own copy to edit.':
    'Celá kresba je zabalená priamo v odkaze – nič sa nikam nenahráva. Kto ho otvorí, uvidí mozaiku a môže si urobiť vlastnú kópiu na úpravy.',
  'Include the tracing photo (makes the link much longer)':
    'Pribaliť fotku na obkreslenie (odkaz bude oveľa dlhší)',
  'Share file…':
    'Zdieľať súbor…',
  'Copy link':
    'Kopírovať odkaz',
  'Switch app':
    'Prepnúť aplikáciu',
  'Vector: tiles as shapes. Raster: paint with pixels. Palettes are shared; copy and paste images between them.':
    'Vektor: dlaždice ako tvary. Raster: maľovanie pixelmi. Palety sú spoločné; obrázky medzi nimi kopírujte a vkladajte.',
  'Simple shows the essentials; Expert adds symmetry, layers, rulers, the knife, printing and fine settings':
    'Jednoduchý ukazuje to podstatné; Expert pridáva symetriu, vrstvy, pravítka, nôž, tlač a jemné nastavenia',
  'New drawing':
    'Nová kresba',
  'Open SVG (Ctrl+O) – you can also drop a file on the canvas':
    'Otvoriť SVG (Ctrl+O) – súbor môžete tiež pretiahnuť na plátno',
  'Save SVG (Ctrl+S)':
    'Uložiť SVG (Ctrl+S)',
  'Save as (Ctrl+Shift+S)':
    'Uložiť ako (Ctrl+Shift+S)',
  'Export a PNG image':
    'Exportovať obrázok PNG',
  'Export a 3D model for printing with filament changes – each color at its own height':
    'Exportovať 3D model na tlač s výmenami filamentu – každá farba vo svojej výške',
  'Copy the drawing (or the selected shapes) as an image – paste it into the raster app or any other program (Ctrl+C)':
    'Skopírovať kresbu (alebo vybrané tvary) ako obrázok – vložíte ho do rastrovej aplikácie alebo akéhokoľvek programu (Ctrl+C)',
  'Print a real-size template with color numbers':
    'Vytlačiť šablónu v skutočnej veľkosti s číslami farieb',
  'Split the mosaic into numbered panels and print a laying plan':
    'Rozdeliť mozaiku na očíslované panely a vytlačiť plán kladenia',
  'Colors used, areas and a shopping list':
    'Použité farby, plochy a nákupný zoznam',
  'Earlier versions of your drawing':
    'Staršie verzie vašej kresby',
  'Share the mosaic as a link':
    'Zdieľať mozaiku ako odkaz',
  'Undo (Ctrl+Z)':
    'Späť (Ctrl+Z)',
  'Redo (Ctrl+Y)':
    'Znova (Ctrl+Y)',
  'Zoom out (-)':
    'Oddialiť (-)',
  'Zoom in (+)':
    'Priblížiť (+)',
  'Fit page (0)':
    'Celá stránka (0)',
  'See the mosaic in black & white or as color-blind people see it (screen only)':
    'Zobraziť mozaiku čiernobielo alebo tak, ako ju vidia ľudia s poruchou farebného videnia (len na obrazovke)',
  'Mark tiles that blend into a neighbouring tile of another color':
    'Označiť dlaždice, ktoré splývajú so susednou dlaždicou inej farby',
  'Language':
    'Jazyk',
  'Install as an app that also works offline':
    'Nainštalovať ako aplikáciu, ktorá funguje aj offline',
  'Show the side panel':
    'Zobraziť bočný panel',
  'Select / edit (V)':
    'Výber / úpravy (V)',
  'Line (L)':
    'Čiara (L)',
  'Free polygon – click corner by corner (P)':
    'Voľný mnohouholník – klikanie roh po rohu (P)',
  'Regular polygon (G)':
    'Pravidelný mnohouholník (G)',
  'Knife – cut a tile straight across (K)':
    'Nôž – rozrezať dlaždicu naprieč (K)',
  'Pattern – fill an area with tiles (T)':
    'Vzor – vyplniť plochu dlaždicami (T)',
  'Paint bucket – click or drag across tiles (B)':
    'Vedro – klik alebo ťahanie cez dlaždice (B)',
  'Pan (H, or hold Space / middle mouse / two fingers)':
    'Posun (H, alebo podržte medzerník / stredné tlačidlo myši / dva prsty)',
  'Your saved palettes':
    'Vaše uložené palety',
  'New palette':
    'Nová paleta',
  'Rename this palette':
    'Premenovať túto paletu',
  'Delete this palette':
    'Zmazať túto paletu',
  'Fill color – used by the paint bucket':
    'Farba výplne – používa ju vedro',
  'Stroke color – used for new lines and polygons':
    'Farba obrysu – pre nové čiary a mnohouholníky',
  'Swap fill and stroke':
    'Vymeniť výplň a obrys',
  'Line width for new lines and polygons':
    'Šírka čiary pre nové čiary a mnohouholníky',
  'Paste #hex, rgb(), name…':
    'Vložte #hex, rgb(), názov…',
  'Load colors from a .txt / .gpl / .css file':
    'Načítať farby zo súboru .txt / .gpl / .css',
  'Add every color used in the drawing':
    'Pridať všetky farby použité v kresbe',
  'Download the palette as a list of hex codes':
    'Stiahnuť paletu ako zoznam kódov hex',
  '0 = as many rows as fit':
    '0 = toľko radov, koľko sa zmestí',
  'Lay out tiles over the whole page and color them from the photo':
    'Rozložiť dlaždice po celej stránke a vyfarbiť ich podľa fotky',
  'Color the tiles you have drawn':
    'Vyfarbiť dlaždice, ktoré ste nakreslili',
  'Grout color':
    'Farba škár',
  'Give every line this color and width for real':
    'Naozaj dať všetkým čiaram túto farbu a šírku',
  'Save the selected shapes as a motif':
    'Uložiť vybrané tvary ako motív',
  'Load motifs from a file':
    'Načítať motívy zo súboru',
  'Download all motifs as a file':
    'Stiahnuť všetky motívy ako súbor',
  'Give the selected painted areas random colors from the mix':
    'Dať vybraným vyfarbeným plochám náhodné farby zo zmesi',
  'Real-world unit: 1 drawing unit = 1 mm / cm / inch':
    'Skutočná jednotka: 1 jednotka kresby = 1 mm / cm / palec',
  'Add a page (front, back, a color variant…)':
    'Pridať stránku (predná strana, zadná strana, farebná varianta…)',
  'Export…':
    'Exportovať…',
  'Copy':
    'Kopírovať',
  'Paste':
    'Vložiť',
  'You are looking at a shared image.':
    'Prezeráte si zdieľaný obrázok.',
  'Back to my image':
    'Späť k môjmu obrázku',
  'Place':
    'Umiestniť',
  'Paint':
    'Maľovanie',
  'Outline':
    'Obrys',
  'From image':
    'Z obrázka',
  'Click a swatch = paint color · right-click = outline color · double-click = edit (also recolors the image). The ∅ swatch paints transparent. Palettes are shared with the vector app.':
    'Klik na vzorkovník = farba maľovania · pravý klik = farba obrysu · dvojklik = upraviť (prefarbí aj obrázok). Vzorkovník ∅ maľuje priehľadne. Palety sú spoločné s vektorovou aplikáciou.',
  'Brush':
    'Štetec',
  'Smooth edges for lines and polygons':
    'Hladké okraje čiar a mnohouholníkov',
  'The pencil always paints hard pixels in exact palette colors – best for pixel mosaics. Shift: straight lines in 15° steps.':
    'Ceruzka vždy kreslí ostré pixely v presných farbách palety – najlepšie pre pixelové mozaiky. Shift: rovné čiary v krokoch po 15°.',
  'Fill with the paint color':
    'Vyplniť farbou maľovania',
  'Outline in the outline color':
    'Obrys vo farbe obrysu',
  'Drag from the center. Shift: 15° rotation steps.':
    'Ťahajte zo stredu. Shift: otáčanie po 15°.',
  'Tolerance':
    'Tolerancia',
  'Only connected pixels':
    'Len súvislé pixely',
  'Fills the area of similar color under the click. Alt+click picks a color.':
    'Vyplní plochu podobnej farby pod kliknutím. Alt+klik vyberie farbu.',
  'Cut':
    'Vystrihnúť',
  'Crop':
    'Orezať',
  'Drag inside the selection to move it (Alt+drag moves a copy), a corner to scale it, the knob above it to turn it; two fingers on it scale and turn it. The bar below it turns, flips, duplicates and deletes. Enter places it, Esc cancels.':
    'Ťahaním vo výbere ho posuniete (Alt+ťahanie posunie kópiu), ťahaním za roh ho zväčšíte či zmenšíte, úchytom nad ním ho otočíte; dvoma prstami na ňom ho zväčšíte, zmenšíte a otočíte. Lišta pod ním otáča, prevracia, duplikuje a maže. Enter ho umiestni, Esc zruší.',
  'Mosaic':
    'Mozaika',
  'Make a mosaic…':
    'Vytvoriť mozaiku…',
  'Reduce to palette':
    'Previesť na paletu',
  'Open as vector tiles…':
    'Otvoriť ako vektorové dlaždice…',
  'Works on the selection, or on the whole image when nothing is selected.':
    'Pracuje s výberom, alebo s celým obrázkom, keď nie je nič vybrané.',
  'Image':
    'Obrázok',
  'Resize image':
    'Zmeniť veľkosť obrázka',
  'Canvas size':
    'Veľkosť plátna',
  'Pixel grid when zoomed in':
    'Mriežka pixelov pri priblížení',
  'Select, Brush, Pencil, Eraser, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Výber, Štetec, Ceruzka, Guma, Čiara, Mnohouholník, Elipsa, Krivka, Vedro, Kvapkadlo, Posun',
  'Smaller / bigger brush':
    'Menší / väčší štetec',
  'Swap paint and outline colors':
    'Vymeniť farbu maľovania a obrysu',
  'Alt+click':
    'Alt+klik',
  'Pick a color':
    'Vybrať farbu',
  'Straight lines, 15° steps':
    'Rovné čiary, kroky po 15°',
  'Copy, cut, paste images (also between the two apps and other programs)':
    'Kopírovať, vystrihnúť, vložiť obrázky (aj medzi oboma aplikáciami a inými programami)',
  'Select all, clear the selection':
    'Vybrať všetko, zrušiť výber',
  'Place / cancel a moved or pasted image':
    'Umiestniť / zrušiť posunutý alebo vložený obrázok',
  'Fit image, actual pixels':
    'Celý obrázok, skutočné pixely',
  'Real width':
    'Skutočná šírka',
  'Pieces are areas of one color (tiles). “Replace with” recolors every pixel of that color.':
    'Dieliky sú plochy jednej farby (dlaždice). „Nahradiť za“ prefarbí všetky pixely tej farby.',
  'The image is packed into the link itself – nothing is uploaded. Whoever opens it sees the image and can make their own copy to edit.':
    'Obrázok je zabalený priamo v odkaze – nič sa nikam nenahráva. Kto ho otvorí, uvidí obrázok a môže si urobiť vlastnú kópiu na úpravy.',
  'Make a mosaic':
    'Vytvoriť mozaiku',
  'Splits the picture into tiles and gives each tile the color underneath it, with grout between the tiles.':
    'Rozdelí obrázok na dlaždice, každej dá farbu, ktorá je pod ňou, a medzi dlaždice dá škáry.',
  'Squares':
    'Štvorce',
  'Squares, offset rows':
    'Štvorce, posunuté rady',
  'Bricks':
    'Tehly',
  'Hexagons':
    'Šesťuholníky',
  'Irregular (crazy paving)':
    'Nepravidelné (mozaika z úlomkov)',
  'Grout':
    'Škáry',
  'Smaller tiles where the picture has detail':
    'Menšie dlaždice tam, kde má obrázok detaily',
  'colors from the picture (new palette)':
    'farieb z obrázka (nová paleta)',
  'Keep the picture’s colors':
    'Zachovať farby obrázka',
  'Open as vector tiles':
    'Otvoriť ako vektorové dlaždice',
  'Every piece of the picture (an area of one color) becomes a tile shape in the vector app, at the real size – ready for its print templates, laying plan, 3D print and editing. Your current vector drawing is kept in its History.':
    'Každý dielik obrázka (plocha jednej farby) sa stane tvarom dlaždice vo vektorovej aplikácii, v skutočnej veľkosti – pripravený na tlačové šablóny, plán kladenia, 3D tlač aj úpravy. Vaša aktuálna vektorová kresba zostane v jej Histórii.',
  'The grout color becomes the page background; every other piece becomes a tile.':
    'Farba škár sa stane pozadím stránky; každý ďalší dielik sa stane dlaždicou.',
  'Open in the vector app':
    'Otvoriť vo vektorovej aplikácii',
  'Format':
    'Formát',
  'JPEG':
    'JPEG',
  'WebP':
    'WebP',
  'Quality':
    'Kvalita',
  'JPEG has no transparency: transparent parts become white.':
    'JPEG nemá priehľadnosť: priehľadné miesta budú biele.',
  'Simple shows the essentials; Expert adds opacity, tolerance, resizing and more':
    'Jednoduchý ukazuje to podstatné; Expert pridáva krytie, toleranciu, zmenu veľkosti a ďalšie',
  'New image':
    'Nový obrázok',
  'Open an image (Ctrl+O) – you can also drop one on the canvas':
    'Otvoriť obrázok (Ctrl+O) – môžete ho tiež pretiahnuť na plátno',
  'Save as PNG (Ctrl+S)':
    'Uložiť ako PNG (Ctrl+S)',
  'Export as JPEG or WebP':
    'Exportovať ako JPEG alebo WebP',
  'Colors used, pieces and a shopping list':
    'Použité farby, dieliky a nákupný zoznam',
  'Earlier versions of your image':
    'Staršie verzie vášho obrázka',
  'Share the image as a link':
    'Zdieľať obrázok ako odkaz',
  'Copy the selection (or the whole image) to the clipboard (Ctrl+C)':
    'Skopírovať výber (alebo celý obrázok) do schránky (Ctrl+C)',
  'Paste an image from the clipboard (Ctrl+V)':
    'Vložiť obrázok zo schránky (Ctrl+V)',
  'Fit image (0)':
    'Celý obrázok (0)',
  'Actual pixels (1)':
    'Skutočné pixely (1)',
  'Select – drag a rectangle, then drag it to move (V)':
    'Výber – ťahajte obdĺžnik a ťahaním ho posuňte (V)',
  'Brush – soft edges (B)':
    'Štetec – mäkké okraje (B)',
  'Pencil – hard pixels in exact colors (P)':
    'Ceruzka – ostré pixely v presných farbách (P)',
  'Eraser (E)':
    'Guma (E)',
  'Paint bucket – fill an area (F)':
    'Vedro – vyplniť plochu (F)',
  'Pick a color (I, or Alt+click with any paint tool)':
    'Kvapkadlo (I, alebo Alt+klik s akýmkoľvek nástrojom maľovania)',
  'Your saved palettes (shared with the vector app)':
    'Vaše uložené palety (spoločné s vektorovou aplikáciou)',
  'Paint color – brush, pencil, lines, polygons and the bucket':
    'Farba maľovania – štetec, ceruzka, čiary, mnohouholníky a vedro',
  'Outline color – the outline of polygons':
    'Farba obrysu – obrys mnohouholníkov',
  'Swap paint and outline colors (X)':
    'Vymeniť farbu maľovania a obrysu (X)',
  'Brush, pencil, eraser and line size in pixels ( [ and ] )':
    'Veľkosť štetca, ceruzky, gumy a čiary v pixeloch ( [ a ] )',
  'Add the colors used in the image (or suggest some for a photo)':
    'Pridať farby použité v obrázku (alebo pri fotke nejaké navrhnúť)',
  'Turn the image (or the selection) into tiles with grout':
    'Previesť obrázok (alebo výber) na dlaždice so škárami',
  'Give every pixel the closest palette color':
    'Dať každému pixelu najbližšiu farbu z palety',
  'Every tile becomes a shape in the vector app – for its templates, laying plan and editing':
    'Každá dlaždica sa stane tvarom vo vektorovej aplikácii – pre jej šablóny, plán kladenia a úpravy',
  'Scale the picture to this size':
    'Zmenšiť / zväčšiť obrázok na túto veľkosť',
  'Change the canvas size, keeping the picture centered':
    'Zmeniť veľkosť plátna, obrázok zostane v strede',
  'The width of the finished mosaic':
    'Šírka hotovej mozaiky',
  'Herringbone':
    'Rybia kosť',
  'Triangles':
    'Trojuholníky',
  'Rings (around the click)':
    'Kruhy (okolo kliknutia)',
  'Rows following the outline':
    'Rady pozdĺž obrysu',
  'portrait':
    'na výšku',
  'landscape':
    'na šírku',
  'Vector':
    'Vektor',
  'Raster':
    'Raster',
  'Fit':
    'Všetko',
  'Thinnest part':
    'Najtenšia časť',
  'Raised parts narrower than this – or more than twice as tall as they are wide – are lowered to what is around them, so nothing prints as a thin tower':
    'Vyvýšené miesta užšie než táto hodnota – alebo viac ako dvakrát vyššie, než sú široké – sa znížia na úroveň okolia, aby sa nič netlačilo ako tenká vežička',
  'Grout colors are always printed first, so the lines between the tiles stay low.':
    'Farby škár sa tlačia vždy ako prvé, takže čiary medzi dlaždicami zostanú nízko.',
  'Grout / lines: always printed first, so they stay low':
    'Škáry / čiary: tlačia sa vždy ako prvé, takže zostanú nízko',
  'grout':
    'škáry',
  '{n} thin {n|piece|pieces} lowered so nothing prints as a thin tower':
    '{n} {n|tenký dielik znížený|tenké dieliky znížené|tenkých dielikov znížených}, aby sa nič netlačilo ako tenká vežička',
  'Top view':
    'Zhora',
  'Drag to turn · wheel or two fingers to zoom · double-click to reset':
    'Ťahaním otáčate · kolieskom alebo dvoma prstami približujete · dvojklik vráti pohľad',
  'Shows the heights taller than they are, to see the color bands':
    'Zobrazí výšky väčšie, než sú, aby boli vidieť farebné vrstvy',
  'Heights ×':
    'Výšky ×',
  'This browser can’t show 3D (WebGL is off).':
    'Tento prehliadač nevie zobraziť 3D (WebGL je vypnuté).',
  'One nozzle – colors by height':
    'Jedna tryska – farby podľa výšky',
  'Several filaments (AMS, MMU…) – flat':
    'Viac filamentov (AMS, MMU…) – plochý',
  'A flat model with one part per color, for printers that switch filaments by themselves. The 3MF file already assigns filament 1, 2, … to the parts – load the filaments in the order listed below.':
    'Plochý model s jedným dielom pre každú farbu, pre tlačiarne, ktoré samy menia filamenty. Súbor 3MF už dielom priraďuje filament 1, 2, … – založte filamenty v poradí uvedenom nižšie.',
  'How thick the tiles are above the base':
    'Aké hrubé sú dlaždice nad podložkou',
  'Tile layers':
    'Vrstvy dlaždíc',
  'Grout colors end this many layers below the tiles, so the lines between them stay low. 0: all flat':
    'Farby škár končia o toľko vrstiev nižšie než dlaždice, takže čiary medzi nimi zostanú nízko. 0: všetko rovno',
  'Grout lower by':
    'Škáry nižšie o',
  'layers':
    'vrstvy',
  'Filaments:':
    'Filamenty:',
  'Grout colors come first and stay lower than the tiles. The base plate uses filament 1.':
    'Farby škár sú prvé a zostávajú nižšie než dlaždice. Podložka sa tlačí filamentom 1.',
  '3MF for':
    '3MF pre',
  'The model, one part per color with its filament':
    'Model, jeden diel pre každú farbu s jej filamentom',
  'One STL file per color, in a ZIP – load them as parts of one object':
    'Jeden súbor STL pre každú farbu, v ZIPe – načítajte ich ako diely jedného objektu',
  '{share} % · filament {k}':
    '{share} % · filament {k}',
  '{n} {n|color|colors} = {n} {n|filament|filaments} · flat, {h} mm high ({layers} {layers|layer|layers})':
    '{n} {n|farba|farby|farieb} = {n} {n|filament|filamenty|filamentov} · plochý, výška {h} mm ({layers} {layers|vrstva|vrstvy|vrstiev})',
  'Base':
    'Podložka',
  'Mosaic Paint – multi-filament plan for {name}.3mf':
    'Mosaic Paint – plán viacerých filamentov pre {name}.3mf',
  'Size {w} × {h} mm · layer height {lh} mm · base {base} {base|layer|layers} · tiles {tile} {tile|layer|layers} · grout {recess} {recess|layer|layers} lower':
    'Veľkosť {w} × {h} mm · výška vrstvy {lh} mm · podložka {base} {base|vrstva|vrstvy|vrstiev} · dlaždice {tile} {tile|vrstva|vrstvy|vrstiev} · škáry o {recess} {recess|vrstvu|vrstvy|vrstiev} nižšie',
  'Total height {total} mm.':
    'Celková výška {total} mm.',
  'Filament {k}: {color} (also the base plate)':
    'Filament {k}: {color} (aj podložka)',
  'Filament {k}: {color}':
    'Filament {k}: {color}',
  '{slicer}: open the 3MF – every color is a part of one object with its filament already assigned. Load the filaments in this order (AMS slots, MMU…).':
    '{slicer}: otvorte 3MF – každá farba je diel jedného objektu a má už priradený filament. Založte filamenty v tomto poradí (sloty AMS, MMU…).',
  'The 3MF is made for {slicer}: other slicers may read it as one part – then use the STL files.':
    '3MF je určený pre {slicer}: iné slicery ho môžu načítať ako jeden diel – potom použite súbory STL.',
  'STL: one file per color in a ZIP. Load them together as one object made of parts and give each its filament.':
    'STL: jeden súbor pre každú farbu v ZIPe. Načítajte ich spoločne ako jeden objekt z dielov a každému priraďte jeho filament.',
  'Saved {name}.3mf for {slicer}: {n} {n|part|parts} with their filaments assigned.':
    'Uložené {name}.3mf pre {slicer}: {n} {n|diel|diely|dielov} s priradenými filamentmi.',
  'Saved {name}-stl.zip: {n} STL {n|file|files}, one per color. Load them as parts of one object.':
    'Uložené {name}-stl.zip: {n} {n|súbor|súbory|súborov} STL, jeden pre každú farbu. Načítajte ich ako diely jedného objektu.',
  'Finishing: frame, corners, hanging hole, magnets':
    'Dokončenie: rámik, rohy, otvor na zavesenie, magnety',
  'A border around the picture. With one nozzle it comes out in the top color, with several filaments in filament 1. 0: none':
    'Okraj okolo obrázka. S jednou tryskou vyjde v hornej farbe, s viacerými filamentmi vo filamente 1. 0: žiadny',
  'Frame':
    'Rámik',
  'How many layers the frame stands above the tiles':
    'O koľko vrstiev rámik prečnieva nad dlaždice',
  'raised by':
    'vyšší o',
  'Radius of the outline’s corners. 0: square':
    'Polomer rohov obrysu. 0: ostré rohy',
  'Rounded corners':
    'Zaoblené rohy',
  'A hole to hang it by, at the top in the middle. 0: none':
    'Otvor na zavesenie, hore v strede. 0: žiadny',
  'Hanging hole':
    'Otvor na zavesenie',
  'Four round pockets in the bottom, one near each corner, to glue magnets in: their diameter. 0: none':
    'Štyri okrúhle vrecká na spodku, pri každom rohu jedno, na vlepenie magnetov: ich priemer. 0: žiadne',
  'Magnets':
    'Magnety',
  'How deep the magnet pockets are (the magnet’s thickness)':
    'Aké hlboké sú vrecká na magnety (hrúbka magnetu)',
  'deep':
    'hĺbka',
  'with the frame {w} × {h} mm, {z} mm high':
    's rámikom {w} × {h} mm, výška {z} mm',
  'The model is too thin for magnet pockets.':
    'Model je na vrecká na magnety príliš tenký.',
  'The magnet pockets are only {d} mm deep – the model is thinner there.':
    'Vrecká na magnety sú hlboké len {d} mm – model je tam tenší.',
  'Frame {w} mm wide, up to layer {layer} (Z {z} mm), in filament 1.':
    'Rámik široký {w} mm, až do vrstvy {layer} (Z {z} mm), filamentom 1.',
  'Frame {w} mm wide: it goes on in {color} up to layer {layer} (Z {z} mm).':
    'Rámik široký {w} mm: pokračuje farbou {color} až do vrstvy {layer} (Z {z} mm).',
  'Magnet pockets in the bottom: 4 × {d} mm, {depth} mm deep – glue the magnets in after printing.':
    'Vrecká na magnety na spodku: 4 × {d} mm, hĺbka {depth} mm – magnety vlepte po vytlačení.',
  'Making the mosaic…':
    'Vytváram mozaiku…',
  'Could not make the mosaic.':
    'Mozaiku sa nepodarilo vytvoriť.',
  'Tracing the tiles…':
    'Obkresľujem dlaždice…',
  'Could not trace the tiles.':
    'Dlaždice sa nepodarilo obkresliť.',
  'Working out the model…':
    'Počítam model…',
  'Working out the model… {p} %':
    'Počítam model… {p} %',
  'Could not build the 3D model.':
    '3D model sa nepodarilo vytvoriť.',
  'Building the 3D model…':
    'Vytváram 3D model…',
  'Building the 3D model… {p} %':
    'Vytváram 3D model… {p} %',
  'Coaster':
    'Podložka pod pohár',
  'HOME':
    'DOMOV',
  'Sign':
    'Tabuľka',
  '100 × 100 mm, square tiles in rings of color – try 3D… with rounded corners.':
    '100 × 100 mm, štvorcové dlaždice vo farebných prstencoch – skúste 3D… so zaoblenými rohmi.',
  'coaster':
    'podlozka',
  'A word in tiles with a border – try Report for a shopping list.':
    'Slovo z dlaždíc s okrajom – v Prehľade nájdete nákupný zoznam.',
  'sign':
    'tabulka',
  'Welcome to Mosaic Paint':
    'Vitajte v Mosaic Paint',
  'Design a mosaic: draw lines or lay a tile pattern, then paint the tiles. Everything is measured in real millimetres.':
    'Navrhnite mozaiku: nakreslite čiary alebo položte vzor dlaždíc a potom dlaždice vyfarbite. Všetko sa meria v skutočných milimetroch.',
  'Draw':
    'Kreslenie',
  'The tools are on the left: lines and shapes, the tile pattern, and the paint bucket that fills a tile with one click.':
    'Nástroje sú vľavo: čiary a tvary, vzor dlaždíc a vedro, ktoré jedným kliknutím vyfarbí dlaždicu.',
  'Pick a color in the palette, then click tiles with the bucket. Palettes are shared with the raster app.':
    'Vyberte farbu v palete a klikajte vedrom na dlaždice. Palety sú spoločné s rastrovou aplikáciou.',
  'When it is done':
    'Keď bude hotovo',
  'Report gives a shopping list, 3D… a model to print, Share a link. Expert mode adds printing at real size and laying plans.':
    'Prehľad dá nákupný zoznam, 3D… model na tlač, Zdieľať odkaz. Režim Expert pridá tlač v skutočnej veľkosti a plány kladenia.',
  'Start from an example':
    'Začnite od príkladu',
  'Not sure where to begin? Open an example. The ? button shows this guide again.':
    'Neviete, kde začať? Otvorte príklad. Tlačidlo ? ukáže tohto sprievodcu znova.',
  'Pixel heart':
    'Pixelové srdce',
  '16 × 16 pixel art – every pixel a tile. Try 3D… or Print.':
    'Pixel art 16 × 16 – každý pixel je dlaždica. Skúste 3D… alebo Tlač.',
  'heart':
    'srdce',
  'Heart':
    'Srdce',
  'Sunset mosaic':
    'Mozaika so západom slnka',
  'A picture made into tiles with grout by “Make a mosaic…”. Try Open as vector tiles.':
    'Obrázok premenený na dlaždice so škárami pomocou „Vytvoriť mozaiku…“. Skúste Otvoriť ako vektorové dlaždice.',
  'sunset':
    'zapad-slnka',
  'Sunset':
    'Západ slnka',
  'Welcome to Mosaic Paint Raster':
    'Vitajte v Mosaic Paint Raster',
  'Paint with pixels: pixel art, or a photo turned into a mosaic. Each pixel can become a tile.':
    'Maľujte pixelmi: pixel art alebo fotku premenenú na mozaiku. Každý pixel sa môže stať dlaždicou.',
  'The tools are on the left: pencil, brush, bucket, lines, shapes and selection.':
    'Nástroje sú vľavo: ceruzka, štetec, vedro, čiary, tvary a výber.',
  'Pick a color in the palette. Palettes are shared with the vector app.':
    'Vyberte farbu v palete. Palety sú spoločné s vektorovou aplikáciou.',
  'Open a photo, then “Make a mosaic…” turns it into tiles with grout in your palette’s colors.':
    'Otvorte fotku a „Vytvoriť mozaiku…“ z nej urobí dlaždice so škárami vo farbách vašej palety.',
  'Examples':
    'Príklady',
  'Open an example to see how it is made, or to start from it. Your current work is kept in History.':
    'Otvorte príklad a pozrite sa, ako je urobený, alebo z neho vyjdite. Vaša súčasná práca zostane v Histórii.',
  'Back':
    'Späť',
  '{k} of {n}':
    '{k} z {n}',
  'Next':
    'Ďalej',
  'Examples…':
    'Príklady…',
  'Example projects to open':
    'Ukážkové projekty na otvorenie',
  'A short guide to the app':
    'Krátky sprievodca aplikáciou',
  'Guide':
    'Sprievodca',
  'Working… {p} %':
    'Pracujem… {p} %',
  'Your photo':
    'Vaša fotka',
  'Load a photo and turn it into tiles – smaller where it has detail.':
    'Načítajte fotku a premeňte ju na dlaždice – menšie tam, kde má detaily.',
  'Read the G-code your slicer made and check it against this plan: filament changes, filaments and heights':
    'Načíta G-code zo slicera a porovná ho s týmto plánom: výmeny filamentu, filamenty a výšky',
  'Check G-code…':
    'Skontrolovať G-code…',
  'Change to {color} at Z {z} mm':
    'Výmena na {color} v Z {z} mm',
  'No filament change to {color} at Z {z} mm':
    'Chýba výmena filamentu na {color} v Z {z} mm',
  'A filament change the plan does not have, at Z {z} mm':
    'Výmena filamentu, ktorú plán nemá, v Z {z} mm',
  'The top is at {z} mm, as planned':
    'Vrch je vo výške {z} mm, podľa plánu',
  'The top is at {found} mm instead of {z} mm':
    'Vrch je vo výške {found} mm namiesto {z} mm',
  'Filament {k} ({color}) is not used – assign it to the part “{k} {color}”':
    'Filament {k} ({color}) sa nepoužíva – priraďte ho dielu „{k} {color}“',
  'Filament {k} ({color}) prints up to {z} mm':
    'Filament {k} ({color}) tlačí do výšky {z} mm',
  'Filament {k} ({color}) prints up to {found} mm instead of {z} mm':
    'Filament {k} ({color}) tlačí do výšky {found} mm namiesto {z} mm',
  'No printing found in {name} – is it a G-code file?':
    'V {name} nie je žiadna tlač – je to súbor G-code?',
  '{name}: {n} {n|thing|things} to look at':
    '{name}: {n} {n|vec|veci|vecí} na kontrolu',
  '{name}: everything matches the plan':
    '{name}: všetko zodpovedá plánu',
  'Reading the G-code…':
    'Čítam G-code…',
  'Reading the G-code… {p} %':
    'Čítam G-code… {p} %',
  'Could not read {name}.':
    '{name} sa nepodarilo prečítať.',
  '{name} is {w} × {h} px – painting on it and making mosaics will be slow. Scale it down to {W} × {H} px?':
    '{name} má {w} × {h} px – maľovanie a mozaiky na ňom budú pomalé. Zmenšiť ho na {W} × {H} px?',
  'It has many colors: “Reduce to palette” or “Make a mosaic…” turn them into a few you can buy tiles in.':
    'Má veľa farieb: „Previesť na paletu“ alebo „Vytvoriť mozaiku…“ z nich urobí pár farieb, v ktorých dlaždice kúpite.',
  '{n} {n|color|colors}':
    '{n} {n|farba|farby|farieb}',
  'Unpin – it may be cleared with old versions':
    'Odopnúť – môže byť zmazaná so starými verziami',
  'Pin – kept when old versions are cleared':
    'Pripnúť – zostane, aj keď sa staré verzie mažú',
  'Name this version':
    'Pomenovať túto verziu',
  'Name of this version:':
    'Názov tejto verzie:',
  'Share link':
    'Odkaz na zdieľanie',
  'What’s new':
    'Čo je nové',
  'Version {v} – what’s new':
    'Verzia {v} – čo je nové',
  'Updated to version {v} – click v{v} in the corner to see what’s new.':
    'Aktualizované na verziu {v} – čo je nové, uvidíte po kliknutí na v{v} v rohu.',
  'The raster app: paint with pixels, turn photos into mosaics, and copy pictures between both apps.':
    'Rastrová aplikácia: maľovanie pixelmi, fotky premenené na mozaiky a kopírovanie obrázkov medzi oboma aplikáciami.',
  '3D print: a 3D preview, models for multi-filament printers (AMS, MMU), a frame, rounded corners, a hanging hole and magnet pockets – and a check of the sliced G-code against the plan.':
    '3D tlač: 3D náhľad, modely pre tlačiarne s viacerými filamentmi (AMS, MMU), rámik, zaoblené rohy, otvor na zavesenie a vrecká na magnety – a kontrola G-codu zo slicera podľa plánu.',
  'Examples to start from, and a short guide for newcomers.':
    'Príklady, od ktorých môžete začať, a krátky sprievodca pre nováčikov.',
  'German, Slovak and Polish.':
    'Nemčina, slovenčina a poľština.',
  'Heavy work – mosaics, tracing, 3D models – no longer holds up the page.':
    'Náročná práca – mozaiky, obkresľovanie, 3D modely – už stránku nezdržiava.',
  'History: name and pin versions; see their size and colors.':
    'História: verzie môžete pomenovať a pripnúť; vidíte ich veľkosť a farby.',
  'Big images can be scaled down when opened.':
    'Veľké obrázky sa dajú pri otvorení zmenšiť.',
  'Better keyboard and screen-reader support.':
    'Lepšia podpora klávesnice a čítačiek obrazovky.',
  'The vector editor: lines, tile patterns, the paint bucket, palettes, reports, printing at real size and sharing as a link.':
    'Vektorový editor: čiary, vzory dlaždíc, vedro, palety, prehľady, tlač v skutočnej veľkosti a zdieľanie odkazom.',
  'Could not sign in to Discord.':
    'Prihlásenie do Discordu zlyhalo.',
  'Post to the channel':
    'Poslať do kanála',
  'Post the picture in this channel, as a reply to the message it came from':
    'Poslať obrázok do tohto kanála ako odpoveď na správu, z ktorej pochádza',
  'That image is no longer available in Discord.':
    'Ten obrázok už na Discorde nie je k dispozícii.',
  'Right-click an image in the chat › Apps › Edit image to edit it here – or open or paste one.':
    'Kliknite pravým tlačidlom na obrázok v chate › Aplikácie › Edit image a upravte ho tu – alebo nejaký otvorte či vložte.',
  'Posted to the channel.':
    'Poslané do kanála.',
  'The picture is too big for Discord – make it smaller (Image › Resize image).':
    'Obrázok je pre Discord príliš veľký – zmenšite ho (Obrázok › Zmeniť veľkosť obrázka).',
  'Could not reach the server.':
    'Server nie je dostupný.',
  'Could not connect to Discord.':
    'Spojenie s Discordom zlyhalo.',
  'Open the editor with “Edit image” (or the app’s launch button) in this chat to post here – or use Copy and paste the picture.':
    'Otvorte editor cez „Edit image“ (alebo tlačidlo aplikácie na spustenie) v tomto chate, aby ste sem mohli poslať obrázok – alebo použite Kopírovať a obrázok vložte.',
  'More than 15 minutes have passed, and Discord no longer lets the app post. Use Copy and paste the picture into the chat.':
    'Uplynulo viac ako 15 minút a Discord už aplikácii nedovolí poslať obrázok. Použite Kopírovať a obrázok vložte do chatu.',
  'Discord did not take the picture. Use Copy and paste it into the chat.':
    'Discord obrázok neprijal. Použite Kopírovať a vložte ho do chatu.',
  'Select the part to keep with the Select tool (V), then crop.':
    'Nástrojom Výber (V) vyberte časť, ktorú chcete ponechať, a potom orežte.',
  'The image is all one color – nothing to trim.':
    'Obrázok je celý jednej farby – nie je čo orezávať.',
  'There is no border to trim.':
    'Nie je tu žiadny okraj na orezanie.',
  'Trimmed to {w} × {h} px.':
    'Orezané na {w} × {h} px.',
  'Pen pressure changes the size':
    'Prítlak pera mení veľkosť',
  'Tip':
    'Hrot',
  'Round':
    'Okrúhly',
  'Soft (airbrush)':
    'Mäkký (airbrush)',
  'Spray':
    'Sprej',
  'Calligraphy':
    'Kaligrafia',
  'Chalk':
    'Krieda',
  'The shape of the brush and eraser':
    'Tvar štetca a gumy',
  'The angle of the calligraphy nib – 45° for right-handed writing, about 135° for left-handed':
    'Uhol kaligrafického hrotu – 45° pre pravákov, asi 135° pre ľavákov',
  'curve through points':
    'krivka cez body',
  'B-spline':
    'B-spline',
  'cubic Bézier':
    'kubická Bézierova krivka',
  'quadratic Bézier':
    'kvadratická Bézierova krivka',
  'ellipse':
    'elipsa',
  'Drag from corner to corner (or from the center) · Shift: a circle · Alt: no snap':
    'Ťahajte z rohu do rohu (alebo zo stredu) · Shift: kruh · Alt: bez prichytávania',
  'Click the curve’s points · click the first point to close it · double-click or Enter ends it open · Backspace removes the last point · Esc cancels':
    'Klikajte na body krivky · kliknutím na prvý bod ju uzavriete · dvojklik alebo Enter ju ukončí otvorenú · Backspace odoberie posledný bod · Esc zruší',
  'Turn on “Fill” or “Outline” for shapes.':
    'Pri tvaroch zapnite „Výplň“ alebo „Obrys“.',
  'Drag from corner to corner (or from the center) · Shift: a circle':
    'Ťahajte z rohu do rohu (alebo zo stredu) · Shift: kruh',
  'The curve runs smoothly through every point you click.':
    'Krivka vedie plynulo cez každý bod, na ktorý kliknete.',
  'The curve is pulled towards each point but only touches the first and the last – very smooth, good for flowing lines.':
    'Krivku každý bod priťahuje, ale dotkne sa len prvého a posledného – veľmi hladká, vhodná na plynulé línie.',
  'Click a point, two control points, the next point, two control points … The curve passes through every third point; the control points (round) pull it.':
    'Kliknite na bod, dva riadiace body, ďalší bod, dva riadiace body … Krivka prechádza každým tretím bodom; riadiace body (okrúhle) ju priťahujú.',
  'Click a point, a control point, the next point, a control point … The curve passes through every other point; the control points (round) pull it.':
    'Kliknite na bod, riadiaci bod, ďalší bod, riadiaci bod … Krivka prechádza každým druhým bodom; riadiace body (okrúhle) ju priťahujú.',
  'Ellipse':
    'Elipsa',
  'From corner':
    'Z rohu',
  'Shift: a circle. Select it to drag its axis ends.':
    'Shift: kruh. Po výbere môžete ťahať konce jej osí.',
  'Curve':
    'Krivka',
  'Type':
    'Typ',
  'Smooth, through the points':
    'Hladká, cez body',
  'Smooth, near the points (B-spline)':
    'Hladká, pri bodoch (B-spline)',
  'Bézier, cubic':
    'Bézierova, kubická',
  'Bézier, quadratic':
    'Bézierova, kvadratická',
  'Ellipse – Shift: circle (O)':
    'Elipsa – Shift: kruh (O)',
  'Curve – click its points (C)':
    'Krivka – klikajte na jej body (C)',
  'Shift: a circle.':
    'Shift: kruh.',
  'An open curve is a line in the paint color, as thick as the size; a closed one is filled and outlined like the shapes.':
    'Otvorená krivka je čiara vo farbe maľovania s nastavenou veľkosťou; uzavretá sa vyplní a obtiahne ako tvary.',
  'Ellipses and curves in both apps: the Ellipse tool (O, Shift for a circle) and the Curve tool (C) – smooth through the points, smooth near them (B-spline), or cubic and quadratic Bézier.':
    'Elipsy a krivky v oboch aplikáciách: nástroj Elipsa (O, so Shiftom kruh) a nástroj Krivka (C) – hladká cez body, hladká pri bodoch (B-spline), alebo kubická a kvadratická Bézierova.',
  'In the vector app, ellipses and curves stay exact curves: drag their points or axis ends to change them, and paint, cut and mirror them like any tile.':
    'Vo vektorovej aplikácii zostávajú elipsy a krivky presnými krivkami: ťahaním bodov alebo koncov osí ich meníte a vyfarbujete, režete a zrkadlíte ich ako každú dlaždicu.',
  'Shift+B':
    'Shift+B',
  'Next brush tip':
    'Ďalší hrot štetca',
  'Brush tip: {tip}':
    'Hrot štetca: {tip}',
  'Brush tips for the brush and the eraser: soft (airbrush), spray, calligraphy and chalk. Shift+B switches between them.':
    'Hroty pre štetec a gumu: mäkký (airbrush), sprej, kaligrafia a krieda. Shift+B medzi nimi prepína.',
  'The spray keeps spraying while you hold it still, like an airbrush; the calligraphy nib’s angle can be set (also for left-handed writing).':
    'Sprej strieka ďalej, aj keď ho držíte na mieste, ako airbrush; uhol kaligrafického hrotu sa dá nastaviť (aj pre ľavákov).',
  'Keep proportions':
    'Zachovať pomer strán',
  'Flip ↔':
    'Prevrátiť ↔',
  'Flip ↕':
    'Prevrátiť ↕',
  'Rotate by':
    'Otočiť o',
  'Rotate':
    'Otočiť',
  'Crop to selection':
    'Orezať na výber',
  'Trim edges':
    'Orezať okraje',
  'With a graphics tablet or stylus, the brush, pencil and eraser paint thinner the lighter you press':
    'S grafickým tabletom alebo perom kreslí štetec, ceruzka a guma tým tenšie, čím ľahšie pritlačíte',
  'Rotate 90° to the left':
    'Otočiť o 90° doľava',
  'Rotate 90° to the right':
    'Otočiť o 90° doprava',
  'Flip left ↔ right':
    'Prevrátiť zľava doprava',
  'Flip upside down':
    'Prevrátiť hore nohami',
  'Rotate by any angle (clockwise; negative: to the left) – the canvas grows to hold the picture':
    'Otočiť o ľubovoľný uhol (v smere hodín; záporný: doľava) – plátno sa zväčší, aby sa obrázok zmestil',
  'Keep only the selection (select it with the Select tool first)':
    'Ponechať len výber (najprv ho vyberte nástrojom Výber)',
  'Cut off the empty or one-color border around the picture':
    'Odrezať prázdny alebo jednofarebný okraj okolo obrázka',
  'Edit images from a Discord chat: right-click › Apps › Edit image, draw on it, post it back – in the raster or the vector app.':
    'Úpravy obrázkov z chatu na Discorde: pravé tlačidlo › Aplikácie › Edit image, kreslite doň a pošlite ho späť – v rastrovej aj vektorovej aplikácii.',
  'Pen pressure: with a graphics tablet or stylus, the brush, pencil and eraser paint thinner the lighter you press.':
    'Prítlak pera: s grafickým tabletom alebo perom kreslí štetec, ceruzka a guma tým tenšie, čím ľahšie pritlačíte.',
  'Image editing in the raster app: rotate (by 90° or any angle), flip, crop to the selection, trim the border, resize keeping proportions.':
    'Úpravy obrázka v rastrovej aplikácii: otočenie (o 90° alebo o ľubovoľný uhol), prevrátenie, orezanie na výber, orezanie okrajov a zmena veľkosti so zachovaním pomeru strán.',
  'Choose a color':
    'Vyberte farbu',
  'Saturation and brightness':
    'Sýtosť a jas',
  'Hue':
    'Odtieň',
  'Before':
    'Predtým',
  'Color code':
    'Kód farby',
  'Also add it to the palette':
    'Pridať ju aj do palety',
  'Use this color':
    'Použiť túto farbu',
  'Choose…':
    'Vybrať…',
  'Choose any color: a color area, a hue slider and a color code':
    'Vyberte ľubovoľnú farbu: farebná plocha, posúvač odtieňa a kód farby',
  'Fill color – used by the paint bucket. Click to choose any color':
    'Farba výplne – používa ju vedierko. Kliknutím vyberiete ľubovoľnú farbu',
  'Stroke color – used for new lines and polygons. Click to choose any color':
    'Farba čiary – pre nové čiary a mnohouholníky. Kliknutím vyberiete ľubovoľnú farbu',
  'Paint color – brush, pencil, lines, polygons and the bucket. Click to choose any color':
    'Farba maľby – štetec, ceruzka, čiary, mnohouholníky a vedierko. Kliknutím vyberiete ľubovoľnú farbu',
  'Outline color – the outline of polygons. Click to choose any color':
    'Farba obrysu – obrys mnohouholníkov. Kliknutím vyberiete ľubovoľnú farbu',
  'Choose any color: a color area, a hue slider and a color code (Choose… under the palette, or click the current colors).':
    'Vyberte ľubovoľnú farbu: farebná plocha, posúvač odtieňa a kód farby (Vybrať… pod paletou, alebo kliknite na aktuálne farby).',
  'Inside Discord: New, Save as, renaming and the other questions work (they are asked in the page now), and switching between the apps keeps the Post button.':
    'V Discorde: Nový, Uložiť ako, premenovanie a ďalšie otázky fungujú (pýtajú sa teraz priamo na stránke) a prepínanie medzi aplikáciami zachová tlačidlo na odoslanie.',
  'On phones inside Discord, the top bar stays clear of Discord’s own controls.':
    'Na telefónoch v Discorde horná lišta nezasahuje pod ovládacie prvky Discordu.',
  'Quick menu':
    'Rýchla ponuka',
  'Undo':
    'Späť',
  'Redo':
    'Znova',
  'Fit to the screen':
    'Prispôsobiť obrazovke',
  'Which color':
    'Ktorá farba',
  'Choose any color':
    'Vybrať ľubovoľnú farbu',
  'The palette is empty – use + to choose a color.':
    'Paleta je prázdna – farbu vyberiete tlačidlom +.',
  'Tip: double-tap the drawing for a quick menu – tools, colors and size.':
    'Tip: dvojitým ťuknutím na kresbu otvoríte rýchlu ponuku – nástroje, farby a veľkosť.',
  'Quick menu on phones and tablets: double-tap the drawing with a finger for undo, the main tools, colors and size – right where you draw.':
    'Rýchla ponuka na telefónoch a tabletoch: dvojitým ťuknutím prstom na kresbu máte poruke späť, hlavné nástroje, farby a veľkosť – priamo tam, kde kreslíte.',
  'Tap or click where to copy from.':
    'Ťuknite alebo kliknite tam, odkiaľ kopírovať.',
  'Tap the image where to copy from':
    'Ťuknite do obrázka tam, odkiaľ kopírovať',
  'Copying from {x}, {y}':
    'Kopíruje sa z {x}, {y}',
  'No source yet: the first tap sets it':
    'Zdroj zatiaľ nie je: nastaví ho prvé ťuknutie',
  'Source set – now paint where the copy goes.':
    'Zdroj nastavený – teraz maľujte tam, kam patrí kópia.',
  'Clone':
    'Klonovanie',
  'Set source':
    'Nastaviť zdroj',
  'Aligned – the source follows the brush':
    'Zarovnane – zdroj sa posúva so štetcom',
  'Set where to copy from, then paint where the copy should go. Drag the source disc to move it. Size, tip and opacity are the brush\'s.':
    'Nastavte, odkiaľ kopírovať, a potom maľujte tam, kam má kópia prísť. Kotúčik zdroja presuniete ťahaním. Veľkosť, hrot a krytie sú ako pri štetci.',
  'Clone – paint with a copy of another part of the image · Alt+click or the first tap sets where to copy from (S)':
    'Klonovanie – maľujte kópiou inej časti obrázka · Alt+klik alebo prvé ťuknutie nastaví, odkiaľ kopírovať (S)',
  'The next tap or click sets where to copy from (or Alt+click)':
    'Ďalšie ťuknutie alebo kliknutie nastaví, odkiaľ kopírovať (alebo Alt+klik)',
  'On: the source moves along with the brush from stroke to stroke. Off: every stroke starts copying from the source':
    'Zapnuté: zdroj sa posúva so štetcom od ťahu k ťahu. Vypnuté: každý ťah začne kopírovať zo zdroja',
  'Clone tool in the raster app (S): paint with a copy of another part of the image. Tap (or Alt+click) where to copy from, paint the copy, drag the source disc with a finger to move it; aligned or not, with the brush’s size, tip, opacity and pen pressure.':
    'Nástroj Klonovanie v rastrovej aplikácii (S): maľujte kópiou inej časti obrázka. Ťuknite (alebo Alt+klik) tam, odkiaľ kopírovať, namaľujte kópiu, kotúčik zdroja posuniete prstom; zarovnane aj nie, s veľkosťou, hrotom, krytím a prítlakom pera ako pri štetci.',
  'Adjust colors':
    'Úprava farieb',
  'Stretch the picture’s tones to the full range':
    'Roztiahnuť tóny obrázka na celý rozsah',
  'Auto':
    'Automaticky',
  'Reset':
    'Vrátiť',
  'Hold to see the picture as it was':
    'Podržte na zobrazenie pôvodného obrázka',
  'Colors adjusted.':
    'Farby upravené.',
  'Heal':
    'Retuš',
  'Adjust colors…':
    'Upraviť farby…',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Výber, Štetec, Ceruzka, Guma, Klonovanie, Retuš, Čiara, Mnohouholník, Elipsa, Krivka, Vedierko, Kvapkadlo, Posun',
  'Heal – like Clone, but the copy takes the color and light of the place you paint: for blemishes, spots and scratches (J)':
    'Retuš – ako Klonovanie, ale kópia prevezme farbu a svetlo miesta, kam maľujete: na škvrny, bodky a škrabance (J)',
  'Brightness, contrast, saturation, levels, sharpening and noise smoothing – for the selection or the whole image':
    'Jas, kontrast, sýtosť, úrovne, doostrenie a vyhladenie šumu – pre výber alebo celý obrázok',
  'Photo fixes in the raster app: Adjust colors… – brightness, contrast, saturation, levels with Auto, sharpening and noise smoothing, previewed live (hold Before to compare).':
    'Úpravy fotiek v rastrovej aplikácii: Upraviť farby… – jas, kontrast, sýtosť, úrovne s tlačidlom Automaticky, doostrenie a vyhladenie šumu, so živým náhľadom (podržaním Predtým porovnáte).',
  'Heal brush (J): paints over blemishes, spots and scratches with texture from elsewhere, in the color and light of the spot.':
    'Retušovací štetec (J): premaľuje škvrny, bodky a škrabance textúrou odinakiaľ, vo farbe a svetle daného miesta.',
  'Filling from the surroundings…':
    'Vypĺňa sa z okolia…',
  'Removed.':
    'Odstránené.',
  'Could not fill it: {why}':
    'Nepodarilo sa vyplniť: {why}',
  'Select what to remove first.':
    'Najprv vyberte, čo odstrániť.',
  'Select':
    'Výber',
  'Rectangle':
    'Obdĺžnik',
  'Lasso':
    'Laso',
  'Magnetic':
    'Magnetické',
  'Wand':
    'Palička',
  'Add':
    'Pridať',
  'Subtract':
    'Ubrať',
  'Drag inside the selection to move it. Copy, Clear, Fill from surroundings and Adjust colors follow its shape.':
    'Ťahaním vnútri výberu ho presuniete. Kopírovať, Vymazať, Vyplniť z okolia a Upraviť farby rešpektujú jeho tvar.',
  'Paint over what should disappear; when you lift, it is filled from the picture around it. Works best on backgrounds – grass, sky, walls, skin.':
    'Premaľujte, čo má zmiznúť; po zdvihnutí sa to vyplní z okolitého obrázka. Najlepšie funguje na pozadí – tráva, obloha, steny, pokožka.',
  'Fill with':
    'Vyplniť pomocou',
  'Surroundings (built in)':
    'Okolie (vstavané)',
  'AI (add-on)':
    'AI (doplnok)',
  'Fill from surroundings':
    'Vyplniť z okolia',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Remove, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Výber, Štetec, Ceruzka, Guma, Klonovanie, Retuš, Odstrániť, Čiara, Mnohouholník, Elipsa, Krivka, Vedierko, Kvapkadlo, Posun',
  'Shift / Alt + select':
    'Shift / Alt + výber',
  'Add to / take away from the selection':
    'Pridať k výberu / ubrať z výberu',
  'Remove – paint over something to make it disappear: it is filled from the picture around it (R)':
    'Odstrániť – premaľujte niečo, aby to zmizlo: vyplní sa to z okolitého obrázka (R)',
  'Shape':
    'Tvar',
  'A rectangle: drag across':
    'Obdĺžnik: ťahajte cez',
  'Freehand: draw around it':
    'Voľnou rukou: obkreslite to',
  'Draw roughly along an edge – the line snaps to it':
    'Kreslite zhruba pozdĺž hrany – čiara sa k nej prichytí',
  'Tap a color: everything similar next to it (or anywhere)':
    'Ťuknite na farbu: všetko podobné vedľa nej (alebo kdekoľvek)',
  'New selection':
    'Nový výber',
  'Replace the selection':
    'Nahradiť výber',
  'Add to the selection (or hold Shift)':
    'Pridať k výberu (alebo držte Shift)',
  'Take away from the selection (or hold Alt)':
    'Ubrať z výberu (alebo držte Alt)',
  'The selected part disappears: filled from the picture around it':
    'Vybraná časť zmizne: vyplní sa z okolitého obrázka',
  'Shaped selections: Lasso, Magnetic (snaps to edges) and Wand (by color), with New / Add / Subtract (or Shift / Alt) – copy, clear, move and Adjust colors follow the shape.':
    'Výbery ľubovoľného tvaru: Laso, Magnetické (prichytí sa k hranám) a Palička (podľa farby), s Nový / Pridať / Ubrať (alebo Shift / Alt) – kopírovanie, mazanie, presun aj Upraviť farby rešpektujú tvar.',
  'Removing things: the Remove brush (R) and Fill from surroundings for a selection fill the spot with the picture around it – content-aware, on the device.':
    'Odstraňovanie: štetec Odstrániť (R) a Vyplniť z okolia pre výber vyplnia miesto okolitým obrázkom – s ohľadom na obsah, priamo v zariadení.',
  'Text':
    'Text',
  'Type here':
    'Píšte sem',
  'Font':
    'Písmo',
  'List the fonts installed on this computer (the browser asks first)':
    'Zobraziť písma nainštalované v tomto počítači (prehliadač sa najprv opýta)',
  'More fonts…':
    'Ďalšie písma…',
  'Style':
    'Rez',
  'Bold':
    'Tučné',
  'Italic':
    'Kurzíva',
  'Alignment':
    'Zarovnanie',
  'Left':
    'Vľavo',
  'Center':
    'Na stred',
  'Right':
    'Vpravo',
  'Shadow':
    'Tieň',
  'The text is in the paint color, its outline in the outline color. Drag it into place, then press Enter or tap outside it.':
    'Text má farbu maľby, obrys farbu obrysu. Presuňte ho na miesto a potom stlačte Enter alebo ťuknite mimo neho.',
  '{n} fonts listed.':
    'Zobrazené písma: {n}.',
  'The browser did not list the fonts.':
    'Prehliadač písma nezobrazil.',
  'Drag the text into place, then press Enter or tap outside it.':
    'Presuňte text na miesto a potom stlačte Enter alebo ťuknite mimo neho.',
  'Tap where to copy from (or Alt+click), then paint the copy · drag the source disc to move it':
    'Ťuknite, odkiaľ kopírovať (alebo Alt+klik), potom maľujte kópiu · kotúčik zdroja posuniete ťahaním',
  'Tap where to copy from (or Alt+click), then paint over the spot – it blends in when you lift':
    'Ťuknite, odkiaľ kopírovať (alebo Alt+klik), potom premaľujte miesto – po zdvihnutí splynie',
  'Paint over what should disappear – it is filled from the surroundings when you lift':
    'Premaľujte, čo má zmiznúť – po zdvihnutí sa vyplní z okolia',
  'Tap to add text · drag it into place · tap it to edit · Enter places it':
    'Ťuknutím pridáte text · presuňte ho na miesto · ťuknutím ho upravíte · Enter ho umiestni',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Remove, Blur, Noise, Twist, Text, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Výber, Štetec, Ceruzka, Guma, Klonovanie, Retuš, Odstrániť, Rozmazanie, Šum, Skrútenie, Text, Čiara, Mnohouholník, Elipsa, Krivka, Vedierko, Kvapkadlo, Posun',
  'Text – tap to type; fonts, outline, shadow and curved text (T)':
    'Text – ťuknite a píšte; písma, obrys, tieň a zakrivený text (T)',
  'Text tool in the raster app (T): any font (also the installed ones, where the browser lists them), size, bold, italic, alignment, outline, shadow and curved text. It floats until placed – drag it, tap it to edit.':
    'Nástroj Text v rastrovej aplikácii (T): ľubovoľné písmo (aj nainštalované, kde ich prehliadač vie zobraziť), veľkosť, tučné, kurzíva, zarovnanie, obrys, tieň a zakrivený text. Do umiestnenia pláva nad obrázkom – presuňte ho, ťuknutím upravíte.',
  'The AI could not start in this browser.':
    'AI sa v tomto prehliadači nepodarilo spustiť.',
  'Starting the AI…':
    'Spúšťa sa AI…',
  'The AI could not do it: {why}':
    'AI to nezvládla: {why}',
  'Looking at the picture…':
    'Prezerá sa obrázok…',
  'Nothing found there – tap the middle of the object.':
    'Nič sa tam nenašlo – ťuknite do stredu objektu.',
  'the AI add-on is not downloaded':
    'doplnok AI nie je stiahnutý',
  'Remove background':
    'Odstrániť pozadie',
  'What is in the picture?':
    'Čo je na obrázku?',
  'People (portraits)':
    'Ľudia (portréty)',
  'Any subject (objects, animals, products)':
    'Čokoľvek (predmety, zvieratá, výrobky)',
  'Each needs a one-time download – the size is shown before anything is downloaded. Everything runs on this device.':
    'Každé potrebuje jednorazové stiahnutie – veľkosť uvidíte skôr, než sa čokoľvek stiahne. Všetko beží v tomto zariadení.',
  'Select the subject':
    'Vybrať hlavný objekt',
  'Finding the subject…':
    'Hľadá sa hlavný objekt…',
  'The subject is selected.':
    'Hlavný objekt je vybraný.',
  'Background removed.':
    'Pozadie odstránené.',
  'Could not load the text recognition.':
    'Rozpoznávanie textu sa nepodarilo načítať.',
  'Reading the text…':
    'Číta sa text…',
  'Text in the picture':
    'Text na obrázku',
  'You can correct it here before copying.':
    'Pred skopírovaním ho tu môžete opraviť.',
  'Copied.':
    'Skopírované.',
  'Select the text and copy it (Ctrl+C).':
    'Označte text a skopírujte ho (Ctrl+C).',
  'No text found.':
    'Nenašiel sa žiadny text.',
  '3D relief':
    '3D reliéf',
  'A 3D-printable relief of the picture (STL): from its brightness, or from the depth an AI sees in a photo.':
    'Reliéf obrázka na 3D tlač (STL): podľa jasu, alebo podľa hĺbky, ktorú vo fotke vidí AI.',
  'Brightness – light is high':
    'Jas – svetlé je vysoko',
  'Brightness – dark is high (a lithophane: hold it against light)':
    'Jas – tmavé je vysoko (litofánia: podržte ju proti svetlu)',
  'Depth (AI add-on) – near is high':
    'Hĺbka (doplnok AI) – blízke je vysoko',
  'Relief':
    'Reliéf',
  'Low':
    'Nízke',
  'Medium':
    'Stredné',
  'High':
    'Vysoké',
  'Smoothing':
    'Vyhladenie',
  'Height map: white is high':
    'Výšková mapa: biela je vysoko',
  'Save STL':
    'Uložiť STL',
  'Working out the depth…':
    'Zisťuje sa hĺbka…',
  '{w} × {h} mm, {z} mm high':
    '{w} × {h} mm, výška {z} mm',
  'Saved relief.stl.':
    'Uložené relief.stl.',
  'Select object (AI)':
    'Výber objektu (AI)',
  'Tap an object to select it.':
    'Ťuknutím na objekt ho vyberiete.',
  'Object removal (AI)':
    'Odstraňovanie objektov (AI)',
  'Remove fills the spot with a trained model – better on objects and structure than the built-in fill.':
    'Odstrániť vyplní miesto natrénovaným modelom – lepšie ako vstavané vyplnenie pri objektoch a štruktúrach.',
  'Background removal – people':
    'Odstránenie pozadia – ľudia',
  'Removes the background behind people (portraits).':
    'Odstráni pozadie za ľuďmi (portréty).',
  'Background removal – any subject':
    'Odstránenie pozadia – čokoľvek',
  'Removes the background behind the main subject: objects, animals, products.':
    'Odstráni pozadie za hlavným objektom: predmety, zvieratá, výrobky.',
  'Read text (OCR)':
    'Čítanie textu (OCR)',
  'Recognizes text in the image, to copy it.':
    'Rozpozná text v obrázku, aby ste ho mohli skopírovať.',
  'Depth for 3D relief (AI)':
    'Hĺbka pre 3D reliéf (AI)',
  'Estimates the depth of a photo for a 3D-printable relief.':
    'Odhadne hĺbku fotky pre reliéf na 3D tlač.',
  'Download failed ({status}).':
    'Sťahovanie zlyhalo ({status}).',
  'This needs a one-time download of {size}.':
    'Potrebuje to jednorazovo stiahnuť {size}.',
  'That includes the AI engine ({size}), shared by all AI add-ons.':
    'To zahŕňa jadro AI ({size}), spoločné pre všetky doplnky AI.',
  'It is kept in this browser and works offline afterwards; the Add-ons list in the side panel removes it again. Everything runs on this device – your pictures are not uploaded.':
    'Zostane v tomto prehliadači a potom funguje aj offline; v zozname Doplnky v bočnom paneli ho zase odstránite. Všetko beží v tomto zariadení – vaše obrázky sa nikam nenahrávajú.',
  'Download {size}':
    'Stiahnuť {size}',
  'Downloading…':
    'Sťahuje sa…',
  '{name} is ready.':
    '{name} je pripravené.',
  'Could not download it: {why}':
    'Nepodarilo sa stiahnuť: {why}',
  'installed':
    'stiahnuté',
  'Download':
    'Stiahnuť',
  'Used by add-ons: {size}. Sizes include the shared AI engine where it is not downloaded yet.':
    'Doplnky zaberajú: {size}. Veľkosti zahŕňajú spoločné jadro AI, ak ešte nie je stiahnuté.',
  'Removed the add-on.':
    'Doplnok odstránený.',
  'Object (AI)':
    'Objekt (AI)',
  'Remove background…':
    'Odstrániť pozadie…',
  'Read text…':
    'Prečítať text…',
  '3D relief…':
    '3D reliéf…',
  'Add-ons':
    'Doplnky',
  'Features that need a one-time download. Nothing is downloaded until you agree; everything runs on this device.':
    'Funkcie, ktoré potrebujú jednorazové stiahnutie. Nič sa nestiahne, kým nesúhlasíte; všetko beží v tomto zariadení.',
  'Tap an object: the AI selects it (an add-on – asks before downloading)':
    'Ťuknite na objekt: AI ho vyberie (doplnok – pred stiahnutím sa opýta)',
  'Make the background transparent, or select the subject (an AI add-on – asks before downloading)':
    'Spriehľadniť pozadie, alebo vybrať hlavný objekt (doplnok AI – pred stiahnutím sa opýta)',
  'Recognize the text in the image or the selection, to copy it (an add-on – asks before downloading)':
    'Rozpoznať text v obrázku alebo výbere a skopírovať ho (doplnok – pred stiahnutím sa opýta)',
  'A 3D-printable relief (STL) from the picture\'s brightness, or from AI depth':
    'Reliéf na 3D tlač (STL) podľa jasu obrázka, alebo podľa hĺbky z AI',
  'Add-ons that run on your device, each downloaded only after you agree to its size: Select object (tap it), AI object removal, background removal, Read text (OCR) and depth for 3D reliefs. The side panel lists them and removes them again.':
    'Doplnky, ktoré bežia vo vašom zariadení a stiahnu sa až po odsúhlasení veľkosti: Výber objektu (ťuknutím), odstraňovanie objektov AI, odstránenie pozadia, Čítanie textu (OCR) a hĺbka pre 3D reliéfy. Bočný panel ich vypisuje a vie ich zase odstrániť.',
  '3D relief…: a printable relief (STL) from the picture\'s brightness – or a lithophane – or from AI depth.':
    '3D reliéf…: reliéf na tlač (STL) podľa jasu obrázka – alebo litofánia – alebo podľa hĺbky z AI.',
  'Layer {n}':
    'Vrstva {n}',
  'Saved as one picture – Save layers (.ora) in the Layers section keeps the layers.':
    'Uložené ako jeden obrázok – vrstvy zachová Uložiť vrstvy (.ora) v časti Vrstvy.',
  'The last layer can’t be deleted.':
    'Poslednú vrstvu nemožno zmazať.',
  'There is no layer under this one.':
    'Pod touto vrstvou žiadna nie je.',
  'Name of the layer:':
    'Názov vrstvy:',
  'Hide this layer':
    'Skryť túto vrstvu',
  'Show this layer':
    'Zobraziť túto vrstvu',
  'Show {name}':
    'Zobraziť {name}',
  'Saved {name} with {n} {n|layer|layers}.':
    'Uložené {name} s {n} {n|vrstvou|vrstvami|vrstvami}.',
  'Opened {name} ({n} {n|layer|layers}).':
    'Otvorené {name} ({n} {n|vrstva|vrstvy|vrstiev}).',
  'Could not read this OpenRaster file.':
    'Tento súbor OpenRaster sa nepodarilo prečítať.',
  'Merge down':
    'Zlúčiť nadol',
  'Flatten':
    'Zlúčiť všetko',
  'Save layers (.ora)':
    'Uložiť vrstvy (.ora)',
  'Painting and the other tools work on the active layer. Tap a layer to make it active, double-click to rename. Save keeps the picture as it looks; Save layers keeps the layers.':
    'Maľovanie a ostatné nástroje pracujú v aktívnej vrstve. Ťuknutím vrstvu aktivujete, dvojklikom premenujete. Uložiť uloží obrázok, ako vyzerá; Uložiť vrstvy zachová vrstvy.',
  'Layers (.ora)':
    'Vrstvy (.ora)',
  'Layers – the top one first':
    'Vrstvy – horná prvá',
  'A new, empty layer above this one':
    'Nová prázdna vrstva nad touto',
  'A copy of this layer':
    'Kópia tejto vrstvy',
  'Move this layer up':
    'Posunúť vrstvu nahor',
  'Move up':
    'Nahor',
  'Move this layer down':
    'Posunúť vrstvu nadol',
  'Move down':
    'Nadol',
  'Delete this layer':
    'Zmazať túto vrstvu',
  'Put this layer onto the one under it':
    'Vložiť túto vrstvu do tej pod ňou',
  'All the layers as one':
    'Všetky vrstvy do jednej',
  'Save every layer in one file (OpenRaster – GIMP, Krita and others open it); Open… opens it again':
    'Uložiť všetky vrstvy do jedného súboru (OpenRaster – otvorí ho GIMP, Krita a ďalšie); Otvoriť… ho zase otvorí',
  'Layers in the raster app: paint on the active layer, show / hide, opacity, move, merge, flatten – undo knows them all. Save layers keeps them in an OpenRaster file (.ora – GIMP and Krita open it), and autosave keeps them too.':
    'Vrstvy v rastrovej aplikácii: maľovanie do aktívnej vrstvy, zobrazenie / skrytie, krytie, presun, zlúčenie – Späť pozná všetko. Uložiť vrstvy ich zachová v súbore OpenRaster (.ora – otvorí ho GIMP aj Krita) a zachová ich aj automatické ukladanie.',
  'The AI add-ons on phones: much less memory (no more crash on iPhone when selecting an object) – the CPU engine on iPhone and iPad, and one feature\'s models at a time.':
    'Doplnky AI na telefónoch: oveľa menej pamäte (výber objektu už na iPhone nespadne) – na iPhone a iPade jadro pre procesor a vždy len modely jednej funkcie.',
  'Frame {n} of {count}':
    'Snímka {n} z {count}',
  '{s} s of {total} s':
    '{s} s z {total} s',
  'Choose a frame':
    'Vyberte snímku',
  'One frame back':
    'O snímku späť',
  'Play / pause':
    'Prehrať / pozastaviť',
  'One frame on':
    'O snímku ďalej',
  'Use this frame':
    'Použiť túto snímku',
  'This video can’t be played here – try a GIF or a screenshot of it.':
    'Toto video sa tu nedá prehrať – skúste GIF alebo jeho snímku obrazovky.',
  'GIFs and videos: open one (or, in Discord, a GIF, a video or a Tenor / Giphy GIF from the chat) and choose the frame to edit – with a slider, frame steps and play.':
    'GIFy a videá: otvorte ich (v Discorde aj GIF, video alebo GIF z Tenoru / Giphy z chatu) a vyberte snímku na úpravu – posúvačom, po snímkach alebo prehraním.',
  'Everything was selected – now nothing is.':
    'Vybraté bolo všetko – teraz nie je nič.',
  'Invert':
    'Obrátiť',
  'Select the other shapes instead (Ctrl+I)':
    'Vybrať namiesto toho ostatné tvary (Ctrl+I)',
  'Adjust':
    'Úpravy',
  'Invert selection':
    'Obrátiť výber',
  'Invert the selection':
    'Obrátiť výber',
  'Brightness, contrast, warmth and the other photo sliders – for the selection or the whole image':
    'Jas, kontrast, teplota a ďalšie posúvače pre fotky – pre výber alebo celý obrázok',
  'Select what isn\'t selected (Ctrl+I)':
    'Vybrať, čo vybraté nie je (Ctrl+I)',
  'Light':
    'Svetlo',
  'Detail and effects':
    'Detaily a efekty',
  'Levels':
    'Úrovne',
  'Vibrance':
    'Živosť',
  'Warmth':
    'Teplota',
  'Tint':
    'Odtieň',
  'Fade':
    'Vyblednutie',
  'Vignette':
    'Vinetácia',
  'Black point':
    'Bod čiernej',
  'White point':
    'Bod bielej',
  'Shadows':
    'Tiene',
  'Highlights':
    'Svetlá',
  'Midtones':
    'Stredné tóny',
  'Nicer icons for undo / redo, zoom, fit and help; Adjust is in the toolbar and the quick menu, with new sliders – shadows, highlights, warmth, tint, vibrance, fade and vignette. Invert selection (Ctrl+I) in both apps.':
    'Krajšie ikony pre späť / znova, priblíženie, prispôsobenie a pomocníka; Úpravy sú na lište aj v rýchlej ponuke s novými posúvačmi – tiene, svetlá, teplota, odtieň, živosť, vyblednutie a vinetácia. Obrátenie výberu (Ctrl+I) v oboch aplikáciách.',
  'Select object (AI) no longer crashes on phones: it now uses MobileSAM, which needs a quarter of the memory (and is faster). Its download is larger (45 MB); the old model is removed.':
    'Výber objektu (AI) už na telefónoch nepadá: teraz používa MobileSAM, ktorý potrebuje štvrtinu pamäte (a je rýchlejší). Sťahovanie je väčšie (45 MB); starý model sa odstráni.',
  'Import a picture':
    'Vložiť obrázok zo súboru',
  'Put a picture from a file into this image – drag it into place, then press Enter (or tap outside it)':
    'Vložiť obrázok zo súboru do tohto obrázka – presuňte ho na miesto a stlačte Enter (alebo ťuknite mimo neho)',
  'Import… puts a picture from a file into the current image (also in the quick menu): it comes in floating, scaled to fit – drag it into place.':
    'Vložiť… pridá obrázok zo súboru do aktuálneho obrázka (aj v rýchlej ponuke): príde ako plávajúci, zmenšený, aby sa zmestil – presuňte ho na miesto.',
  'Two fingers on a selection':
    'Dva prsty na výbere',
  'Scale, turn and move it (spread, pinch, twist)':
    'Zväčšiť, zmenšiť, otočiť a posunúť (roztiahnutie, stiahnutie, otočenie prstov)',
  'Two fingers on a selection (or a pasted, imported picture or text) scale and turn it: spread or pinch, twist – and move it. It snaps upright and to its own size, and is always made from the original pixels, so it doesn’t blur. Elsewhere two fingers zoom the view as before.':
    'Dva prsty na výbere (alebo na vloženom či importovanom obrázku a texte) ho zväčšia, zmenšia a otočia: roztiahnite alebo stiahnite prsty, otočte nimi – a posuňte ho. Prichytí sa k zvislej polohe a k pôvodnej veľkosti a vždy vzniká z pôvodných pixelov, takže sa nerozmazáva. Inde dva prsty približujú zobrazenie ako predtým.',
  'On phones, the Select shapes (and other rows of choices) wrap onto a second line instead of cutting off the last one – Object (AI) can be tapped again.':
    'Na telefónoch sa tvary výberu (aj iné rady volieb) zalomia na druhý riadok namiesto toho, aby sa posledná odrezala – Výber objektu (AI) sa dá zase stlačiť.',
  'Drag a corner of the selection':
    'Ťahanie za roh výberu',
  'Scale it (the opposite corner stays)':
    'Zväčšiť či zmenšiť (protiľahlý roh zostane na mieste)',
  'Scale a selection with the mouse: drag one of the handles in its corners – the opposite corner stays put and the proportions are kept. As with two fingers, it is always made from the original pixels.':
    'Zmena veľkosti výberu myšou: ťahajte za jeden z úchytov v jeho rohoch – protiľahlý roh zostane na mieste a pomer strán sa zachová. Rovnako ako pri dvoch prstoch vzniká vždy z pôvodných pixelov.',
  'Paint to soften – edges of pasted photos blend in · [ ] size · a soft tip blends best':
    'Maľovaním zjemníte – okraje vložených fotiek splynú · [ ] veľkosť · najlepšie splýva mäkký hrot',
  'Paint to add grain – a smooth patch matches the photo around it · [ ] size':
    'Maľovaním pridáte zrno – hladká plocha ladí s fotkou okolo · [ ] veľkosť',
  'Blur':
    'Rozmazanie',
  'Noise':
    'Šum',
  'Strength':
    'Sila',
  'Amount':
    'Množstvo',
  'Colored grain':
    'Farebné zrno',
  'To blend a photo in: blur along its edge, then add a little grain so it matches the picture around it. Each stroke adds more; the tip and opacity are the brush\'s.':
    'Ako fotku napojiť: rozmažte jej okraj a potom pridajte trochu zrna, aby ladila s obrázkom okolo. Každý ťah pridá viac; hrot a krytie sú ako pri štetci.',
  'Blur – paint to soften: blends the edges of a pasted photo into the picture (U)':
    'Rozmazanie – maľovaním zjemníte: okraje vloženej fotky splynú s obrázkom (U)',
  'Noise – paint to add grain: makes a smooth or pasted part match a photo\'s texture (N)':
    'Šum – maľovaním pridáte zrno: hladká alebo vložená časť dostane textúru fotky (N)',
  'How soft: about this many pixels':
    'Ako jemne: zhruba o toľko pixelov',
  'How much grain':
    'Koľko zrna',
  'Off: the same grain in red, green and blue (like film). On: each its own':
    'Vypnuté: rovnaké zrno v červenej, zelenej aj modrej (ako film). Zapnuté: každá farba svoje',
  'Blur (U) and Noise (N) brushes, to blend photos into each other: blur along the edge of a pasted photo to soften it (a cut-out’s edge fades out), then add a little grain so it matches the picture around it.':
    'Štetce Rozmazanie (U) a Šum (N) na napájanie fotiek: rozmažte okraj vloženej fotky, aby zmäkol (okraj výrezu sa vytratí), a pridajte trochu zrna, aby ladila s obrázkom okolo.',
  'In a narrower window the top bar scrolls on its own instead of pushing the whole page sideways (the canvas could slide out of view).':
    'V užšom okne sa horná lišta posúva sama namiesto toho, aby odsunula celú stránku do strany (plátno mohlo zmiznúť z dohľadu).',
  'Compress video…':
    'Zmenšiť video…',
  'Make a video small enough for Discord – on your device – and post it here':
    'Zmenšiť video tak, aby sa zmestilo do Discordu – vo vašom zariadení – a zverejniť ho tu',
  'Compress a video':
    'Zmenšiť video',
  'The video is made smaller on your device, then posted to the channel.':
    'Video sa zmenší vo vašom zariadení a potom sa zverejní v kanáli.',
  'Choose a video…':
    'Vybrať video…',
  'Small enough already – it is posted as it is.':
    'Už je dosť malé – zverejní sa tak, ako je.',
  'Use as it is':
    'Použiť, ako je',
  'Compress':
    'Zmenšiť',
  'Too long for {size} MB – the picture would be very poor. Choose the larger size or a shorter video.':
    'Na {size} MB je príliš dlhé – obraz by bol veľmi zlý. Zvoľte väčšiu veľkosť alebo kratšie video.',
  '→ about {w} × {h}, {rate} Mbit/s':
    '→ asi {w} × {h}, {rate} Mbit/s',
  'Opening {name}…':
    'Otváram {name}…',
  'This video can’t be read here – try another one (MP4, MOV or WebM).':
    'Toto video sa tu nedá prečítať – skúste iné (MP4, MOV alebo WebM).',
  'Could not compress the video.':
    'Video sa nepodarilo zmenšiť.',
  '{size} (was {before})':
    '{size} (bolo {before})',
  'without sound (this browser can’t make it)':
    'bez zvuku (tento prehliadač ho nevie vytvoriť)',
  'still too big – choose the larger size or a shorter video':
    'stále príliš veľké – zvoľte väčšiu veľkosť alebo kratšie video',
  'Discord did not take a video this big – try 10 MB.':
    'Discord také veľké video neprijal – skúste 10 MB.',
  'Use “Compress video” on a message or /compress-video in this chat to post here.':
    'Na zverejnenie tu použite „Compress video“ na správe alebo /compress-video v tomto chate.',
  'More than 15 minutes have passed, and Discord no longer lets the app post. Run /compress-video again.':
    'Uplynulo viac ako 15 minút a Discord už aplikácii nedovolí nič zverejniť. Spustite /compress-video znova.',
  'Discord did not take the video.':
    'Discord video neprijal.',
  'Choose a video from your device.':
    'Vyberte video zo svojho zariadenia.',
  'Discord: compress a video to fit Discord’s limit and post it – right-click a message with a video › Apps › Compress video, or /compress-video for a video from your device. It is made smaller on your device (20 MB or 10 MB), shown, then posted.':
    'Discord: zmenšite video, aby sa zmestilo do limitu Discordu, a zverejnite ho – pravým tlačidlom na správu s videom › Aplikácie › Compress video, alebo /compress-video pre video zo zariadenia. Zmenší sa vo vašom zariadení (20 MB alebo 10 MB), ukáže sa a potom zverejní.',
  'Turn left 90°':
    'Otočiť doľava o 90°',
  'Turn right 90°':
    'Otočiť doprava o 90°',
  'Flip horizontally':
    'Prevrátiť vodorovne',
  'Flip vertically':
    'Prevrátiť zvisle',
  'Duplicate – leave a copy here and move this one on':
    'Duplikovať – kópia zostane tu a tento sa posunie ďalej',
  'Delete the selected pixels (Del)':
    'Zmazať vybrané pixely (Del)',
  'Drag the knob above a selection':
    'Ťahanie úchytu nad výberom',
  'Turn it (Shift: 15° steps)':
    'Otočiť (Shift: po 15°)',
  'A selection now has a knob above it to turn it (it snaps upright; Shift: 15° steps) and a bar below it: turn left / right, flip horizontally / vertically, duplicate, delete, cancel, place – with the mouse or a finger.':
    'Výber má teraz nad sebou úchyt na otáčanie (prichytí sa zvisle; Shift: po 15°) a pod sebou lištu: otočiť doľava / doprava, prevrátiť vodorovne / zvisle, duplikovať, zmazať, zrušiť, umiestniť – myšou aj prstom.',
  'Press at the centre, drag out for the size, then go round it to twist – the further round, the stronger · lift to finish':
    'Stlačte v strede, ťahajte von pre veľkosť, potom krúžte okolo a krúťte – čím ďalej okolo, tým silnejšie · zdvihnutím dokončíte',
  'Twist':
    'Skrútenie',
  'Press where the swirl\'s centre should be and drag out: the circle shows how far it reaches. Then go round the centre – the further round, the stronger the twist (back the other way to undo it). Lift to finish; with a selection, only the selected pixels twist.':
    'Stlačte tam, kde má byť stred víru, a ťahajte von: kruh ukazuje, kam až siaha. Potom krúžte okolo stredu – čím ďalej okolo, tým silnejšie skrútenie (späť ho vrátite). Zdvihnutím dokončíte; s výberom sa skrútia len vybrané pixely.',
  'Twist – press, drag out for the size, go round to swirl the picture (W)':
    'Skrútenie – stlačte, ťahajte von pre veľkosť, krúžte okolo a obrázok sa zavíri (W)',
  'Twist tool (W): press where the swirl’s centre should be, drag out for its size, then go round – the further round, the stronger the twist (either way). With a selection, only the selected pixels twist.':
    'Nástroj Skrútenie (W): stlačte tam, kde má byť stred víru, ťahajte von pre jeho veľkosť a potom krúžte okolo – čím ďalej okolo, tým silnejšie skrútenie (oboma smermi). S výberom sa skrútia len vybrané pixely.',
  'Click a line or shape to pick it, then drag it – or press Delete':
    'Klikni na čiaru alebo tvar, vyber ho a potom ho potiahni – alebo stlač Delete',
  'Drag to draw a line – it sticks to the lines and corners already there':
    'Ťahaj a nakresli čiaru – prichytí sa k čiaram a rohom, ktoré už tam sú',
  'Drag from the middle to draw a shape – pick how many corners on the right':
    'Ťahaj od stredu a nakresli tvar – vpravo vyber, koľko má mať rohov',
  'Drag to draw a circle or an oval':
    'Ťahaj a nakresli kruh alebo ovál',
  'Click inside an area to fill it with tiles':
    'Klikni dovnútra plochy a vyplň ju dlaždicami',
  'Pick a color, then click a tile to paint it – or drag across many tiles':
    'Vyber farbu a klikni na dlaždicu, aby sa vyfarbila – alebo ťahaj cez viac dlaždíc',
  'Make a mosaic: draw the lines between the tiles, or fill an area with tiles, then paint each tile.':
    'Urob si mozaiku: nakresli čiary medzi dlaždicami alebo vyplň plochu dlaždicami, potom každú dlaždicu vyfarbi.',
  'Pick a tool on the left: Line, Shapes and Circles draw, Tiles fills an area with tiles, Paint colors a tile when you click it.':
    'Vľavo vyber nástroj: Čiara, Tvary a Kruhy kreslia, Dlaždice vyplnia plochu dlaždicami, Farba vyfarbí dlaždicu, na ktorú klikneš.',
  'Click a color, then click the tiles with Paint. Made a mistake? The arrow at the top takes it back.':
    'Klikni na farbu a potom na dlaždice s nástrojom Farba. Pomýlil si sa? Šípka hore to vráti.',
  'Shapes':
    'Tvary',
  'Circles':
    'Kruhy',
  'Small tiles':
    'Malé dlaždice',
  'Big':
    'Veľké',
  'Simple: only the drawing tools and the colors – for children and quick mosaics. Expert: everything':
    'Jednoduchý: len kresliace nástroje a farby – pre deti a rýchle mozaiky. Expert: všetko',
  'Tile size':
    'Veľkosť dlaždíc',
  'The vector app’s Simple mode is now made for children: only the basic tools (with a word under each) – Select, Line, Shapes, Circles, Tiles, Paint – and big colors; on phones and tablets the colors are along the bottom too. Everything else is in Expert mode.':
    'Jednoduchý režim vektorovej aplikácie je teraz pre deti: len základné nástroje (každý s popisom) – Výber, Čiara, Tvary, Kruhy, Dlaždice, Farba – a veľké farby; na telefónoch a tabletoch sú farby aj dole. Všetko ostatné je v režime Expert.',
  'Remove the picture?':
    'Odstrániť obrázok?',
  'Picture loaded – draw over it.':
    'Obrázok je načítaný – kresli cez neho.',
  'Choose another picture…':
    'Vybrať iný obrázok…',
  'Choose a picture…':
    'Vybrať obrázok…',
  'Shards':
    'Črepy',
  'Hand-laid lines':
    'Ručne kladené špáry',
  'Uneven, tapered lines – as if the shards were laid by hand':
    'Nerovné, zužujúce sa špáry – akoby črepy kládol človek',
  'Shuffle':
    'Zamiešať',
  'Unevenness':
    'Nerovnosť',
  'Picture to draw over':
    'Obrázok pod kresbou',
  'Shards – uneven, tapered lines, as if the glass were laid by hand (click again: even lines)':
    'Črepy – nerovné, zužujúce sa špáry, akoby sklo kládol človek (znova: rovné špáry)',
  'Other widths for every piece':
    'Iné šírky pre každý kúsok',
  'Simple mode: Choose a picture… puts a picture under the drawing to draw the tile shapes over (it can fade, or go).':
    'Jednoduchý režim: Vybrať obrázok… vloží obrázok pod kresbu, cez ktorý kreslíš tvary dlaždíc (dá sa zosvetliť alebo odstrániť).',
  'Shards (both modes): uneven, tapered lines, as if glass shards were laid by hand – every piece between two crossings gets its own width, wider at one end. Shuffle for other widths; Unevenness in the panel. The lines stay as they are underneath; files and pictures keep the look.':
    'Črepy (v oboch režimoch): nerovné, zužujúce sa špáry, akoby sklenené črepy kládol človek – každý kúsok medzi dvoma kríženiami má vlastnú šírku, na jednom konci širší. Zamiešať dá iné šírky; Nerovnosť je v paneli. Čiary pod tým zostanú, ako sú; súbory aj obrázky ten vzhľad zachovajú.',
  'Off: every tile gets the one color you picked. Turn it on to give each tile one of these {n} colors at random.':
    'Vypnuté: každá dlaždica dostane tú jednu farbu, ktorú vyberieš. Zapni to a každá dlaždica dostane náhodne jednu z týchto {n} farieb.',
  'Mixing off – painting with one color. (Mix colors in the Paint options turns it on again.)':
    'Miešanie vypnuté – maľuje sa jednou farbou. (Zapne ho znova Miešať farby v možnostiach Farby.)',
  '＋ Add a color':
    '＋ Pridať farbu',
  'Clear palette':
    'Vymazať paletu',
  'Choose any color and add it to the palette':
    'Vybrať ľubovoľnú farbu a pridať ju do palety',
  'Remove all colors from the palette':
    'Odobrať z palety všetky farby',
  'Picking one color (a swatch without Shift) switches the color mix off – the bucket paints with that color. The Mix colors switch shows in Simple mode too, and so do ＋ Add a color and Clear palette.':
    'Výber jednej farby (vzorkovník bez Shiftu) vypne miešanie farieb – vedierko maľuje touto farbou. Prepínač Miešať farby je aj v jednoduchom režime, rovnako ako ＋ Pridať farbu a Vymazať paletu.',
  'Set up the palette':
    'Nastaviť paletu',
  'Copy colors on any website – a palette site, color codes, a list – and paste them here (Ctrl+V). Every color found shows below; click one to leave it out.':
    'Skopíruj farby na akejkoľvek webovej stránke – na webe s paletami, kódy farieb, zoznam – a vlož ich sem (Ctrl+V). Každá nájdená farba sa ukáže nižšie; kliknutím ju vynecháš.',
  'Paste from clipboard':
    'Vložiť zo schránky',
  'Colors to paste':
    'Farby na vloženie',
  'Colors found':
    'Nájdené farby',
  'Add to my palette':
    'Pridať do mojej palety',
  'Use instead of my palette':
    'Použiť namiesto mojej palety',
  'Use these colors':
    'Použiť tieto farby',
  '{n} {n|color|colors} found.':
    '{n|Nájdená|Nájdené|Nájdených} {n} {n|farba|farby|farieb}.',
  'No colors found in this text – copy the color codes (like #2a9d8f), not just the picture.':
    'V tomto texte nie sú žiadne farby – skopíruj kódy farieb (napríklad #2a9d8f), nie len obrázok.',
  'This browser won’t let the page read the clipboard – click in the box and press Ctrl+V.':
    'Tento prehliadač stránke nedovolí čítať schránku – klikni do poľa a stlač Ctrl+V.',
  'The palette now has {n} {n|color|colors}.':
    'Paleta má teraz {n} {n|farbu|farby|farieb}.',
  'Added {n} {n|color|colors} to the palette.':
    'Do palety {n|pribudla|pribudli|pribudlo} {n} {n|farba|farby|farieb}.',
  'All these colors are in the palette already.':
    'Všetky tieto farby už v palete sú.',
  'Paste colors…':
    'Vložiť farby…',
  'Paste colors copied on another website':
    'Vložiť farby skopírované na inom webe',
  'Visible – click to hide':
    'Viditeľná – kliknutím skryjete',
  'Hidden – click to show':
    'Skrytá – kliknutím zobrazíte',
  'Locked – click to unlock':
    'Zamknutá – kliknutím odomknete',
  'Unlocked – click to lock':
    'Odomknutá – kliknutím zamknete',
  'Paste colors… sets up the palette from colors copied on another website – a palette site like Coolors, color codes, CSS: every color found shows, click one to leave it out, then add them or use them instead of the palette (both apps).':
    'Vložiť farby… nastaví paletu z farieb skopírovaných na inom webe – na webe s paletami ako Coolors, kódy farieb, CSS: každá nájdená farba sa ukáže, kliknutím ju vynecháš, potom ich pridáš alebo použiješ namiesto palety (v oboch aplikáciách).',
  'done':
    'hotovo',
  '{n} of {m} tasks done':
    'Hotových {n} z {m} úloh',
  'Next: {title}':
    'Ďalej: {title}',
  'Look around':
    'Rozhliadni sa',
  'A ladybird is hiding in the meadow. Zoom in and find it!':
    'Na lúke sa skrýva lienka. Priblíž si obrázok a nájdi ju!',
  'Zoom in to see details, move around with the hand (or two fingers), and Fit shows the whole picture.':
    'Priblížením uvidíš detaily, rúčkou (alebo dvoma prstami) sa posúvaš a Prispôsobiť ukáže celý obrázok.',
  'Tap Zoom in to look closer.':
    'Ťukni na Priblížiť a pozri sa bližšie.',
  'Spread two fingers on the picture to zoom in.':
    'Roztiahni dva prsty na obrázku a priblížiš ho.',
  'Tap the hand – it moves the picture.':
    'Ťukni na rúčku – posúva obrázok.',
  'Drag the picture until you find the ladybird.':
    'Ťahaj obrázok, kým nenájdeš lienku.',
  'You found it! Now tap Fit to see the whole picture again.':
    'Máš ju! Teraz ťukni na Prispôsobiť a uvidíš znova celý obrázok.',
  'Night sky':
    'Nočná obloha',
  'The night sky needs glowing stars. Paint them with a soft brush.':
    'Nočná obloha potrebuje žiariace hviezdy. Namaľuj ich mäkkým štetcom.',
  'The Brush paints soft lines. Size makes it bigger, and the Soft tip makes it glow at the edges.':
    'Štetec maľuje mäkké čiary. Veľkosť ho zväčší a mäkký hrot ho na okrajoch rozžiari.',
  'Tap the Brush.':
    'Ťukni na Štetec.',
  'Tap the yellow color.':
    'Ťukni na žltú farbu.',
  'Choose the Soft tip – it glows at the edges.':
    'Vyber mäkký hrot – na okrajoch žiari.',
  'Make the brush big: slide Size to 30 or more.':
    'Zväčši štetec: posuň Veľkosť na 30 alebo viac.',
  'Paint over the 3 stars.':
    'Premaľuj 3 hviezdy.',
  'Fill the heart square by square – like a real mosaic.':
    'Vyplň srdce štvorček po štvorčeku – ako skutočnú mozaiku.',
  'The Pencil paints whole squares in exactly the chosen color – just right for pixel art.':
    'Ceruzka maľuje celé štvorčeky presne vybranou farbou – akurát na pixel art.',
  'Tap the Pencil.':
    'Ťukni na Ceruzku.',
  'Tap the red color.':
    'Ťukni na červenú farbu.',
  'Make the pencil as small as it goes: slide Size all the way left.':
    'Zmenši ceruzku, čo najviac to ide: posuň Veľkosť úplne doľava.',
  'Fill the inside of the heart, square by square.':
    'Vyplň vnútro srdca, štvorček po štvorčeku.',
  'Muddy window':
    'Zablatené okno',
  'Someone threw mud at the window. Rub it off!':
    'Niekto hodil na okno blato. Vygumuj ho!',
  'The Eraser takes paint away – where it rubs, the picture becomes see-through (the checkerboard).':
    'Guma farbu uberá – kde gumuje, je obrázok priehľadný (šachovnica).',
  'Tap the Eraser.':
    'Ťukni na Gumu.',
  'Make it big: slide Size to 30 or more.':
    'Zväčši ju: posuň Veľkosť na 30 alebo viac.',
  'Rub out the 4 mud spots.':
    'Vygumuj 4 škvrny od blata.',
  'Copy the color':
    'Skopíruj farbu',
  'The parrot lost a feather. Paint a new one in exactly the same purple.':
    'Papagáj stratil pero. Namaľuj nové presne rovnakou fialovou.',
  'The color picker takes a color from the picture. (Tip: Alt+click does it with any brush.)':
    'Kvapkadlo vezme farbu z obrázka. (Tip: s akýmkoľvek štetcom to urobí Alt+klik.)',
  'Tap the color picker – the dropper.':
    'Ťukni na Kvapkadlo.',
  'Tap a purple feather to take its color.':
    'Ťukni na fialové pero a vezmeš si jeho farbu.',
  'Now take the Brush.':
    'Teraz vezmi Štetec.',
  'Make it bigger: Size 20 or more.':
    'Zväčši ho: Veľkosť 20 alebo viac.',
  'Paint the white feather purple.':
    'Namaľuj biele pero nafialovo.',
  'Color the comic':
    'Vyfarbi komiks',
  'Fill the shapes with color – one tap each.':
    'Vyplň tvary farbou – každý jedným ťuknutím.',
  'The Paint bucket fills a whole area at once. Tolerance decides how different the colors in it may be.':
    'Vedierko vyplní celú plochu naraz. Tolerancia určuje, ako veľmi sa v nej môžu farby líšiť.',
  'Tap the Paint bucket.':
    'Ťukni na Vedierko.',
  'Tap the orange color.':
    'Ťukni na oranžovú farbu.',
  'Tap inside the circle, the square and the triangle.':
    'Ťukni dovnútra kruhu, štvorca a trojuholníka.',
  'This box is shaded. Slide Tolerance up to 60 or more.':
    'Tento obdĺžnik je tieňovaný. Posuň Toleranciu na 60 alebo viac.',
  'Now tap inside the shaded box – all of it fills.':
    'Teraz ťukni dovnútra tieňovaného obdĺžnika – vyplní sa celý.',
  'Fence':
    'Plot',
  'The garden needs a fence. Draw the posts with straight lines.':
    'Záhrada potrebuje plot. Nakresli stĺpiky rovnými čiarami.',
  'The Line tool draws straight lines from where you press to where you let go.':
    'Čiara kreslí rovné čiary od miesta, kde stlačíš, po miesto, kde pustíš.',
  'Tap the Line tool.':
    'Ťukni na nástroj Čiara.',
  'Tap the dark color.':
    'Ťukni na tmavú farbu.',
  'Make the line thicker: Size 8 or more.':
    'Zhrubni čiaru: Veľkosť 8 alebo viac.',
  'Draw a line from each bottom dot up to the dot above it.':
    'Nakresli čiaru od každej spodnej bodky hore k bodke nad ňou.',
  'Beehive':
    'Úľ',
  'Bees build cells with 6 sides. Draw 3 honeycomb cells.':
    'Včely stavajú bunky so 6 stranami. Nakresli 3 plásty.',
  'The Polygon tool draws shapes with as many sides as you choose – filled, outlined or both.':
    'Mnohouholník kreslí tvary s toľkými stranami, koľko zvolíš – vyplnené, obtiahnuté alebo oboje.',
  'Tap the Polygon tool.':
    'Ťukni na nástroj Mnohouholník.',
  'Tap 6 – a honeycomb cell has 6 sides.':
    'Ťukni na 6 – bunka plástu má 6 strán.',
  'Turn on Fill – the cells will be full of color.':
    'Zapni Výplň – bunky budú plné farby.',
  'Drag from the middle of each cell outwards.':
    'Ťahaj od stredu každej bunky von.',
  'Bubbles':
    'Bubliny',
  'Blow 3 round soap bubbles – just the outline, you can see through them.':
    'Vyfúkni 3 okrúhle mydlové bubliny – len obrys, je cez ne vidieť.',
  'The Ellipse tool draws circles and ovals. From center starts in the middle; Fill and Outline decide how it looks.':
    'Elipsa kreslí kruhy a ovály. Od stredu začína v strede; Výplň a Obrys určujú, ako vyzerá.',
  'Tap the Ellipse tool.':
    'Ťukni na nástroj Elipsa.',
  'Choose From center.':
    'Vyber Od stredu.',
  'Turn Fill off – a bubble is see-through.':
    'Vypni Výplň – bublina je priehľadná.',
  'Turn Outline on.':
    'Zapni Obrys.',
  'Drag from the middle of each bubble to its edge.':
    'Ťahaj od stredu každej bubliny k jej okraju.',
  'Snake':
    'Had',
  'Draw a wiggly snake through the dots.':
    'Nakresli vlnitého hada cez bodky.',
  'The Curve tool draws a smooth line through the points you tap – double-tap (or Enter) finishes it.':
    'Krivka kreslí hladkú čiaru cez body, na ktoré ťukneš – dvojité ťuknutie (alebo Enter) ju dokončí.',
  'Tap the Curve tool.':
    'Ťukni na nástroj Krivka.',
  'Tap the green color.':
    'Ťukni na zelenú farbu.',
  'Make it a fat snake: Size 10 or more.':
    'Nech je had hrubý: Veľkosť 10 alebo viac.',
  'Tap the dots one by one from the head to the tail – tap the last one twice to finish.':
    'Ťukaj na bodky jednu po druhej od hlavy k chvostu – na poslednú ťukni dvakrát a je hotovo.',
  'Move the cat':
    'Presuň mačku',
  'The cat wants to sleep on the red cushion. Carry it there!':
    'Mačka chce spať na červenom vankúši. Prenes ju tam!',
  'Select a part of the picture with a box, drag it somewhere else, then Place it.':
    'Vyber časť obrázka obdĺžnikom, potiahni ju inam a potom ju Umiestni.',
  'Tap the Select tool.':
    'Ťukni na nástroj Výber.',
  'Drag a box around the whole cat.':
    'Natiahni obdĺžnik okolo celej mačky.',
  'Now drag the cat onto the cushion.':
    'Teraz potiahni mačku na vankúš.',
  'Tap Place – the cat lies down.':
    'Ťukni na Umiestniť – mačka si ľahne.',
  'The fish turns round':
    'Rybka sa otočí',
  'The fish wants to swim the other way – and a little upwards.':
    'Rybka chce plávať na druhú stranu – a trochu hore.',
  'A selection can be flipped, and turned with the round knob above it.':
    'Výber sa dá prevrátiť a otočiť okrúhlym úchytom nad ním.',
  'Drag a box around the fish.':
    'Natiahni obdĺžnik okolo rybky.',
  'Tap Flip horizontally – the fish looks the other way.':
    'Ťukni na Prevrátiť vodorovne – rybka sa pozerá na druhú stranu.',
  'Drag the round knob above the fish a little to the side.':
    'Posuň okrúhly úchyt nad rybkou trochu nabok.',
  'Tap Place.':
    'Ťukni na Umiestniť.',
  'Two balloons':
    'Dva balóny',
  'One balloon is not enough. Cut it out along its edge and make a second one.':
    'Jeden balón nestačí. Vystrihni ho pozdĺž okraja a urob druhý.',
  'The Lasso selects any shape you draw around. Duplicate leaves a copy and gives you a new one to move.':
    'Laso vyberie akýkoľvek tvar, ktorý obkreslíš. Duplikovať nechá kópiu a dá ti novú na posunutie.',
  'Choose Lasso – it goes around any shape.':
    'Vyber Laso – obkreslí akýkoľvek tvar.',
  'Draw a line all the way around the balloon.':
    'Obtiahni čiaru úplne okolo balóna.',
  'Tap Duplicate.':
    'Ťukni na Duplikovať.',
  'Drag the new balloon over to the empty sky.':
    'Potiahni nový balón na prázdnu oblohu.',
  'Change the blue sky into an orange sunset.':
    'Zmeň modrú oblohu na oranžový západ slnka.',
  'The Wand selects everything of one color with a single tap. Clear empties the selection.':
    'Prútik jedným ťuknutím vyberie všetko jednej farby. Vymazať výber vyprázdni.',
  'Choose the Wand – it picks one color.':
    'Vyber Prútik – vyberie jednu farbu.',
  'Tap the blue sky.':
    'Ťukni na modrú oblohu.',
  'Tap Clear – the sky disappears.':
    'Ťukni na Vymazať – obloha zmizne.',
  'Now take the Paint bucket.':
    'Teraz vezmi Vedierko.',
  'Tap the empty sky – a sunset!':
    'Ťukni na prázdnu oblohu – západ slnka!',
  'Name poster':
    'Plagát s menom',
  'Write your name on the green banner.':
    'Napíš svoje meno na zelený pruh.',
  'The Text tool writes words in any size and font – with an outline, a shadow or bent in a curve.':
    'Text píše slová v akejkoľvek veľkosti a písme – s obrysom, tieňom alebo do oblúka.',
  'Tap the Text tool.':
    'Ťukni na nástroj Text.',
  'Tap in the middle of the green banner.':
    'Ťukni doprostred zeleného pruhu.',
  'Type your name.':
    'Napíš svoje meno.',
  'Make the letters big: Size 60.':
    'Zväčši písmená: Veľkosť 60.',
  'Turn on Outline.':
    'Zapni Obrys.',
  'Tap Done.':
    'Ťukni na Hotovo.',
  'Drag your name into the banner.':
    'Potiahni svoje meno do pruhu.',
  'Twin flowers':
    'Kvetinové dvojčatá',
  'One pot is empty. Grow the same flower in it – copy it with Clone.':
    'Jeden kvetináč je prázdny. Vypestuj v ňom rovnaký kvet – skopíruj ho Klonovaním.',
  'Clone paints with a copy of another part of the picture: first tap where to copy from, then paint.':
    'Klonovanie maľuje kópiou inej časti obrázka: najprv ťukni, odkiaľ kopírovať, potom maľuj.',
  'Tap the Clone tool – the stamp.':
    'Ťukni na Klonovanie – pečiatku.',
  'Make it big: Size 30 or more.':
    'Zväčši ho: Veľkosť 30 alebo viac.',
  'Tap the middle of the flower – the copy comes from there.':
    'Ťukni doprostred kvetu – odtiaľ sa bude kopírovať.',
  'Start in the middle of the dashed circle, then paint all over it – a twin flower grows!':
    'Začni v strede čiarkovaného kruhu a potom ho celý premaľuj – vyrastie kvetinové dvojča!',
  'Fix the apple':
    'Oprav jablko',
  'The apple has 3 scratches. Heal them so it looks new.':
    'Jablko má 3 škrabance. Zahoj ich, nech vyzerá ako nové.',
  'Heal copies a clean part and blends it in, so spots and scratches disappear.':
    'Retuš skopíruje čisté miesto a splynie s okolím, takže škvrny a škrabance zmiznú.',
  'Tap the Heal tool – the plaster.':
    'Ťukni na Retuš – náplasť.',
  'Tap a clean part of the apple.':
    'Ťukni na čisté miesto jablka.',
  'Paint over the 3 scratches.':
    'Premaľuj 3 škrabance.',
  'Clean beach':
    'Čistá pláž',
  'Someone left a can on the beach. Make it disappear!':
    'Niekto nechal na pláži plechovku. Nechaj ju zmiznúť!',
  'Remove fills what you paint over from the picture around it – things vanish.':
    'Odstrániť vyplní, čo premaľuješ, obrázkom z okolia – veci zmiznú.',
  'Tap the Remove tool.':
    'Ťukni na nástroj Odstrániť.',
  'Paint over the whole can, then lift your finger.':
    'Premaľuj celú plechovku a potom zdvihni prst.',
  'Star sticker':
    'Hviezdna nálepka',
  'The star looks stuck on. Soften its edge with Blur and give it grain with Noise.':
    'Hviezda vyzerá ako nalepená. Zjemni jej okraj Rozmazaním a daj jej zrno Šumom.',
  'Blur softens, Noise adds grain – together they blend a pasted picture into a photo.':
    'Rozmazanie zjemňuje, Šum pridáva zrno – spolu napoja vložený obrázok do fotky.',
  'Tap the Blur tool – the drop.':
    'Ťukni na Rozmazanie – kvapku.',
  'Make it stronger: slide Strength to 6 or more.':
    'Zosilni ho: posuň Silu na 6 alebo viac.',
  'Paint along the edge of the star.':
    'Maľuj pozdĺž okraja hviezdy.',
  'Now tap the Noise tool – the dots.':
    'Teraz ťukni na Šum – bodky.',
  'Slide Amount to 30 or more.':
    'Posuň Množstvo na 30 alebo viac.',
  'Paint over the star – it gets grainy, like the photo.':
    'Premaľuj hviezdu – bude zrnitá ako fotka.',
  'Whirlpool':
    'Vír',
  'Stir up the lake – make a whirlpool in the circle.':
    'Rozvír jazero – urob v kruhu vír.',
  'Twist swirls the picture: press the middle, drag out for the size, go round to twist.':
    'Skrútenie zavíri obrázok: stlač stred, ťahaj von pre veľkosť a krúžením krúť.',
  'Tap the Twist tool – the spiral.':
    'Ťukni na Skrútenie – špirálu.',
  'Press in the middle of the circle, drag out to its edge, then go round and round.':
    'Stlač v strede kruhu, ťahaj von k jeho okraju a potom krúž dookola.',
  'Painting':
    'Maľovanie',
  'Selecting and moving':
    'Výber a presúvanie',
  'Photo magic':
    'Kúzla s fotkou',
  'Lessons':
    'Lekcie',
  'Open the editor':
    'Otvoriť editor',
  'Learn the tools':
    'Nauč sa nástroje',
  'Small tasks, one tool at a time. A glowing frame shows what to tap next – just follow it.':
    'Malé úlohy, jeden nástroj po druhom. Žiariaci rámček ukazuje, na čo ťuknúť – stačí ho nasledovať.',
  '← All tasks':
    '← Všetky úlohy',
  '🔊 Read aloud':
    '🔊 Prečítať nahlas',
  '↺ Start again':
    '↺ Znova',
  'Well done!':
    'Výborne!',
  'All tasks':
    'Všetky úlohy',
  'Lesson':
    'Lekcia',
  'Back to all tasks':
    'Späť na všetky úlohy',
  'Read the instruction aloud':
    'Prečítať pokyn nahlas',
  'Start this task again':
    'Začať túto úlohu znova',
  'Mosaic Paint Raster':
    'Mosaic Paint Raster',
  'Lessons: learn every tool step by step →':
    'Lekcie: nauč sa každý nástroj krok za krokom →',
  'Lessons (learn.html, linked from the raster app’s ? guide): 20 small tasks that teach every raster tool, one at a time. A glowing frame shows what to tap next – the tool, its setting, the part of the picture – and the next step comes by itself. The Curve tool now shows the Size slider.':
    'Lekcie (learn.html, odkaz je v sprievodcovi ? v rastrovej aplikácii): 20 malých úloh, ktoré naučia každý rastrový nástroj, jeden po druhom. Žiariaci rámček ukazuje, na čo ťuknúť – nástroj, jeho nastavenie, časť obrázka – a ďalší krok príde sám. Nástroj Krivka teraz ukazuje posuvník Veľkosť.',
};
